<template>
  <v-navigation-drawer
    fixed
    app
    floating
    :expand-on-hover="!$vuetify.breakpoint.mobile && mini"
    :value="drawer"
    :temporary="$vuetify.breakpoint.mobile"
    :width="drawerWidth"
    :class="drawerClasses"
    :data-color="sidebarColor"
    :data-theme="sidebarTheme"
    @input="handleDrawerInput"
  >
    <v-list-item class="drawer-brand-list-item pa-0">
      <v-list-item-content class="pa-0">
        <v-list-item-title class="title d-flex align-center mb-0">
        </v-list-item-title>
        <div class="v-navigation-drawer-brand pa-5 d-flex align-center">
          <ModalImagem
            :id="$store.state.inquilino.id"
            :imagem="$store.state.inquilino.imagem"
            :modalImagem="modalImagem"
            @modalImagem="modalImagem = $event"
          >
            <v-list-item-avatar class="align-self-center" color="white" contain>
              <v-img
                :src="this.$store.state.inquilino.imagem"
                max-height="40"
                @click="modalImagem = true"
              />
            </v-list-item-avatar>
          </ModalImagem>
          <ChangeTenant
            v-if="$store.state.user && $store.state.user.id"
            :text="profile.title"
          />
        </div>
      </v-list-item-content>
    </v-list-item>

    <hr class="horizontal dark mb-4" />
    <PesquisaMenu
      :key="$store.state.inquilino.id"
      :payload="navigationMenuItems"
      :active="drawer !== false"
      @navigate="handleNavigationSelect"
    ></PesquisaMenu>
    <hr class="horizontal dark mb-4" />

    <v-list nav dense>
      <v-list-group
        :ripple="false"
        v-for="(item, itemIndex) in computedItems"
        :key="menuItemKey(item, itemIndex)"
        v-model="item.active"
        append-icon="fas fa-angle-down"
        class="pb-1 mx-2"
        active-class="item-active"
        :id="item.title"
        :title="$t(item.title)"
        :data-tutorial-menu-group-title="item.title"
        data-tutorial-menu-source="drawer-group"
      >
        <template v-slot:activator>
          <v-list-item-icon class="shadow border-radius-md mx-2 align-center">
            <div v-html="item.action">
              {{ item.action }}
            </div>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title
              v-text="$t(item.title)"
              class="ms-1"
            ></v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-item
          :ripple="false"
          link
          class="mb-0 no-default-hover"
          :class="child.active ? 'item-active' : ''"
          v-for="(child, childIndex) in visibleMenuChildren(item.items)"
          :key="menuItemKey(child, childIndex, item.title)"
          :to="child.link"
          :id="child.title"
          :title="$t(item.title)"
          :data-tutorial-menu-link="child.link"
          :data-tutorial-menu-title="child.title"
          :data-tutorial-menu-group-title="item.title"
          data-tutorial-menu-source="drawer"
          v-can="child.can"
          exact
          @click="child.items ? null : handleNavigationSelect($event)"
        >
          <span class="v-list-item-mini">
            <v-list-item-icon>
              <v-icon v-text="child.prefix"></v-icon> </v-list-item-icon
          ></span>

          <v-list-item-content class="ms-6 ps-7" v-if="!child.items">
            <v-list-item-title v-text="$t(child.title)"></v-list-item-title>
          </v-list-item-content>

          <v-list-item-content class="ms-6 ps-7 py-0" v-if="child.items">
            <v-list-group
              prepend-icon=""
              :ripple="false"
              sub-group
              no-action
              v-model="child.active"
            >
              <template v-slot:activator>
                <span class="v-list-item-mini">
                  <v-list-item-icon>
                    <v-icon v-text="child.prefix"></v-icon> </v-list-item-icon
                ></span>
                <v-list nav dense class="pa-0">
                  <v-list-group
                    :ripple="false"
                    append-icon="fas fa-angle-down me-auto ms-1"
                    active-class="item-active"
                    class="mb-0"
                  >
                    <template v-slot:activator class="mb-0">
                      <v-list-item-content class="py-0">
                        <v-list-item-title
                          v-text="$t(child.title)"
                        ></v-list-item-title>
                      </v-list-item-content>
                    </template>
                  </v-list-group>
                </v-list>
              </template>

              <v-list-item
                v-for="(child2, child2Index) in visibleMenuChildren(
                  child.items,
                )"
                :ripple="false"
                :key="menuItemKey(child2, child2Index, child.title)"
                :to="child2.link"
                @click="handleNavigationSelect($event)"
                :id="child2.title"
                :data-tutorial-menu-link="child2.link"
                :data-tutorial-menu-title="child2.title"
                :data-tutorial-menu-group-title="item.title"
                data-tutorial-menu-source="drawer"
              >
                <v-list-item-content>
                  <span class="v-list-item-mini">
                    <v-list-item-icon>
                      <v-icon
                        v-text="child2.prefix"
                      ></v-icon> </v-list-item-icon
                  ></span>
                  <v-list-item-title
                    v-text="$t(child2.title)"
                  ></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
    </v-list>

    <v-card
      class="pa-0 border-radius-lg mt-7 mb-9 mx-4"
      :style="`background-image: url(${require('../assets/img/curved-images/white-curved.jpeg')}); background-size: cover;`"
    >
      <span
        class="mask opacity-8 border-radius-lg"
        :class="`bg-gradient-secondary`"
      ></span>
      <div class="px-4 py-4 position-relative" v-if="!clienteCofreInteligente">
        <!-- <v-avatar
          color="bg-white"
          class="shadow"
          width="32"
          height="32"
          min-width="32"
          rounded
        >
          <v-icon size="20" class="text-gradient" :class="`text-success`">
            ni ni-diamond
          </v-icon>
        </v-avatar> -->
        <div class="docs-info">
          <v-card-text class="text-white text-h6 ps-0 pb-0">
            Precisa de ajuda?
          </v-card-text>

          <v-card-subtitle
            v-if="!isWhiteLabelClient"
            class="text-white pt-0 ps-0"
          >
            Você pode acessar nosso canal no YouTube ou falar com nosso suporte
          </v-card-subtitle>

          <v-card-subtitle
            v-if="isWhiteLabelClient"
            class="text-white pt-0 ps-0"
          >
            Você pode entrar em contato com nosso suporte clicando no botão
            abaixo
          </v-card-subtitle>

          <!-- Botão YouTube (externo) -->
          <v-btn
            v-if="!isWhiteLabelClient"
            elevation="0"
            :ripple="false"
            small
            class="
              font-weight-bolder
              text-uppercase
              btn-white
              py-4
              px-6
              rounded-md
              me-2
              my-2
              w-100
            "
            href="https://www.youtube.com/@cajupe"
            target="_blank"
            color="#fff"
          >
            <v-icon class="mr-2">fab fa-brands fa-youtube</v-icon>
            YouTube
          </v-btn>

          <!-- Botão Suporte (rota interna) -->
          <v-btn
            elevation="0"
            :ripple="false"
            small
            class="
              font-weight-bolder
              text-uppercase
              btn-white
              py-4
              px-6
              rounded-md
              me-2
              my-2
              w-100
            "
            :to="{ path: '/dashboard/suporte' }"
            color="#fff"
          >
            <v-icon class="mr-2">mdi-wechat</v-icon>
            {{ isWhiteLabelClient ? "Suporte" : "Suporte Cajupe" }}
          </v-btn>

          <v-btn
            v-if="hasInternalSupportOption"
            elevation="0"
            :ripple="false"
            small
            class="
              font-weight-bolder
              text-uppercase
              btn-white
              py-4
              px-6
              rounded-md
              me-2
              my-2
              w-100
            "
            :to="{
              path: '/dashboard/suporte',
              query: { escopo: 'INTERNO' },
            }"
            color="#fff"
          >
            <v-icon class="mr-2">mdi-account-group</v-icon>
            {{ internalSupportButtonLabel }}
          </v-btn>
        </div>
      </div>
    </v-card>
  </v-navigation-drawer>
</template>
<script>
import { podeOportunidades } from "@/utils/oportunidadesPublicas";
import ChangeTenant from "@/components/base/proprios/ChangeTenant";
import ModalImagem from "@/components/base/proprios/ModalImagem";
import PesquisaMenu from "@/components/base/proprios/PesquisaMenu";
import {
  hasModulo,
  hasPermission,
  normalizeMenuPath,
  routeMatchesMenuLink,
} from "@/utils/menuNavigation";
import {
  hasInternalSupport,
  hasInternalSupportPermission,
  hasProjectSupportPermission,
  internalSupportLabel,
  resolveCurrentTenant,
} from "@/utils/supportContext";
import {
  isClientWhiteLabel,
  resolveAppWhiteLabelBrand,
} from "@/utils/whiteLabel";
import { mapState } from "vuex";

export default {
  name: "drawer",
  components: { PesquisaMenu, ModalImagem, ChangeTenant },
  props: {
    drawer: {
      type: Boolean,
      default: null,
    },
    sidebarColor: {
      type: String,
      default: "danger",
    },
    sidebarTheme: {
      type: String,
      default: "transparent",
    },
    expandOnHover: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    mini: false,
    togglerActive: false,
    modalImagem: false,

    items: [
      {
        title: "Configuracoes",
        active: false,
        icon: "mdi-cog",
        prefix: "mdi-cog",
        action:
          '<svg width="12px" height="12px" viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>settings</title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-2020.000000, -442.000000)" fill="#FFFFFF" fill-rule="nonzero"><g transform="translate(1716.000000, 291.000000)"><g transform="translate(304.000000, 151.000000)"><polygon class="color-background" opacity="0.596981957" points="18.0883333 15.7316667 11.1783333 8.82166667 13.3333333 6.66666667 6.66666667 0 0 6.66666667 6.66666667 13.3333333 8.82166667 11.1783333 15.315 17.6716667"></polygon><path class="color-background" d="M31.5666667,23.2333333 C31.0516667,23.2933333 30.53,23.3333333 30,23.3333333 C29.4916667,23.3333333 28.9866667,23.3033333 28.48,23.245 L22.4116667,30.7433333 L29.9416667,38.2733333 C32.2433333,40.575 35.9733333,40.575 38.275,38.2733333 L38.275,38.2733333 C40.5766667,35.9716667 40.5766667,32.2416667 38.275,29.94 L31.5666667,23.2333333 Z" opacity="0.596981957"></path><path class="color-background" d="M33.785,11.285 L28.715,6.215 L34.0616667,0.868333333 C32.82,0.315 31.4483333,0 30,0 C24.4766667,0 20,4.47666667 20,10 C20,10.99 20.1483333,11.9433333 20.4166667,12.8466667 L2.435,27.3966667 C0.95,28.7083333 0.0633333333,30.595 0.00333333333,32.5733333 C-0.0583333333,34.5533333 0.71,36.4916667 2.11,37.89 C3.47,39.2516667 5.27833333,40 7.20166667,40 C9.26666667,40 11.2366667,39.1133333 12.6033333,37.565 L27.1533333,19.5833333 C28.0566667,19.8516667 29.01,20 30,20 C35.5233333,20 40,15.5233333 40,10 C40,8.55166667 39.685,7.18 39.1316667,5.93666667 L33.785,11.285 Z"></path></g></g></g></g></svg>',
        can: "ROLE_Inquilino_myRecord_Update",
        items: [
          {
            title: "configuracoes.inquilino",
            prefix: "mdi-cog",
            link: "/dashboard/inquilinos/configuracoes",
            can: "ROLE_Inquilino_myRecord_Update",
            icon: "mdi-cog",
          },
        ],
      },

      {
        title: "Acessos",
        active: false,
        action:
          '<svg width="12px" height="12px" viewBox="0 0 40 44" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>document</title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1870.000000, -591.000000)" fill="#FFFFFF" fill-rule="nonzero"><g transform="translate(1716.000000, 291.000000)"><g transform="translate(154.000000, 300.000000)"><path class="color-background" d="M40,40 L36.3636364,40 L36.3636364,3.63636364 L5.45454545,3.63636364 L5.45454545,0 L38.1818182,0 C39.1854545,0 40,0.814545455 40,1.81818182 L40,40 Z" opacity="0.603585379"></path><path class="color-background" d="M30.9090909,7.27272727 L1.81818182,7.27272727 C0.814545455,7.27272727 0,8.08727273 0,9.09090909 L0,41.8181818 C0,42.8218182 0.814545455,43.6363636 1.81818182,43.6363636 L30.9090909,43.6363636 C31.9127273,43.6363636 32.7272727,42.8218182 32.7272727,41.8181818 L32.7272727,9.09090909 C32.7272727,8.08727273 31.9127273,7.27272727 30.9090909,7.27272727 Z M18.1818182,34.5454545 L7.27272727,34.5454545 L7.27272727,30.9090909 L18.1818182,30.9090909 L18.1818182,34.5454545 Z M25.4545455,27.2727273 L7.27272727,27.2727273 L7.27272727,23.6363636 L25.4545455,23.6363636 L25.4545455,27.2727273 Z M25.4545455,20 L7.27272727,20 L7.27272727,16.3636364 L25.4545455,16.3636364 L25.4545455,20 Z"></path></g></g></g></g></svg>',
        group: "acessos",
        can: "ROLE_MENU_Acessos",
        prefix: "mdi-account-lock",
        items: [
          {
            title: "Usuarios",
            prefix: "mdi-account-cog",
            link: "/dashboard/usuarios",
            can: "ROLE_Usuario_List",
          },
        ],
      },

      {
        title: "SPR_Solicitacao_de_Ponto_Remoto",
        active: false,
        action:
          '<svg width="12px" height="12px" viewBox="0 0 40 44" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>document</title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1870.000000, -591.000000)" fill="#FFFFFF" fill-rule="nonzero"><g transform="translate(1716.000000, 291.000000)"><g transform="translate(154.000000, 300.000000)"><path class="color-background" d="M40,40 L36.3636364,40 L36.3636364,3.63636364 L5.45454545,3.63636364 L5.45454545,0 L38.1818182,0 C39.1854545,0 40,0.814545455 40,1.81818182 L40,40 Z" opacity="0.603585379"></path><path class="color-background" d="M30.9090909,7.27272727 L1.81818182,7.27272727 C0.814545455,7.27272727 0,8.08727273 0,9.09090909 L0,41.8181818 C0,42.8218182 0.814545455,43.6363636 1.81818182,43.6363636 L30.9090909,43.6363636 C31.9127273,43.6363636 32.7272727,42.8218182 32.7272727,41.8181818 L32.7272727,9.09090909 C32.7272727,8.08727273 31.9127273,7.27272727 30.9090909,7.27272727 Z M18.1818182,34.5454545 L7.27272727,34.5454545 L7.27272727,30.9090909 L18.1818182,30.9090909 L18.1818182,34.5454545 Z M25.4545455,27.2727273 L7.27272727,27.2727273 L7.27272727,23.6363636 L25.4545455,23.6363636 L25.4545455,27.2727273 Z M25.4545455,20 L7.27272727,20 L7.27272727,16.3636364 L25.4545455,16.3636364 L25.4545455,20 Z"></path></g></g></g></g></svg>',
        group: "ponto",
        can: "ROLE_MENU_Ponto",
        prefix: "mdi-calendar-clock",
        items: [
          {
            title: "FuncionarioPontoSolicitacao",
            prefix: "mdi-account-cancel-outline",
            link: "/dashboard/funcionarioPontoSolicitacoes",
            can: "ROLE_FuncionarioPontoSolicitacao_List",
          },
        ],
      },

      {
        title: "Ponto-RRP",
        active: false,
        action:
          '<svg width="12px" height="12px" viewBox="0 0 40 44" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>document</title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1870.000000, -591.000000)" fill="#FFFFFF" fill-rule="nonzero"><g transform="translate(1716.000000, 291.000000)"><g transform="translate(154.000000, 300.000000)"><path class="color-background" d="M40,40 L36.3636364,40 L36.3636364,3.63636364 L5.45454545,3.63636364 L5.45454545,0 L38.1818182,0 C39.1854545,0 40,0.814545455 40,1.81818182 L40,40 Z" opacity="0.603585379"></path><path class="color-background" d="M30.9090909,7.27272727 L1.81818182,7.27272727 C0.814545455,7.27272727 0,8.08727273 0,9.09090909 L0,41.8181818 C0,42.8218182 0.814545455,43.6363636 1.81818182,43.6363636 L30.9090909,43.6363636 C31.9127273,43.6363636 32.7272727,42.8218182 32.7272727,41.8181818 L32.7272727,9.09090909 C32.7272727,8.08727273 31.9127273,7.27272727 30.9090909,7.27272727 Z M18.1818182,34.5454545 L7.27272727,34.5454545 L7.27272727,30.9090909 L18.1818182,30.9090909 L18.1818182,34.5454545 Z M25.4545455,27.2727273 L7.27272727,27.2727273 L7.27272727,23.6363636 L25.4545455,23.6363636 L25.4545455,27.2727273 Z M25.4545455,20 L7.27272727,20 L7.27272727,16.3636364 L25.4545455,16.3636364 L25.4545455,20 Z"></path></g></g></g></g></svg>',
        group: "ponto",
        can: "ROLE_MENU_Ponto",
        prefix: "mdi-calendar-clock",
        items: [
          {
            title: "Periodo",
            prefix: "mdi-map-clock-outline",
            link: "/dashboard/funcionarioPontoPeriodos",
            can: "ROLE_FuncionarioPonto_Update",
          },
          {
            title: "Registros_de_ponto",
            prefix: "mdi-account-clock-outline",
            link: "/dashboard/funcionariopontos",
            can: "ROLE_FuncionarioPonto_List",
          },

          {
            title: "CalculoPonto",
            prefix: "mdi-calculator-variant-outline",
            link: "/dashboard/funcionariopontocalculos",
            can: "ROLE_FuncionarioPonto_List",
          },
          {
            title: "PessoalGestaoComunicacoes",
            prefix: "mdi-email-fast-outline",
            link: "/dashboard/pessoalGestaoComunicacoes",
            can: "ROLE_PessoalGestaoComunicacoes_Manage",
          },

          {
            title: "Dashboard_batidas_funcionario",
            prefix: "mdi-chart-timeline-variant",
            link: "/dashboard/funcionariopontos/dashboard",
            can: "ROLE_FuncionarioPonto_List",
          },
          {
            title: "Dashboard_cerca_perimetro",
            prefix: "mdi-map-marker-radius-outline",
            link: "/dashboard/funcionariopontos/cerca-perimetro",
            can: "ROLE_FuncionarioPonto_List",
          },

          {
            title: "Dashboard_apuracoes_ponto_mod01",
            prefix: "mdi-chart-box-outline",
            link: "/dashboard/relatorios/funcionariopontos",
            can: "ROLE_FuncionarioPonto_Dashboard",
          },
          {
            title: "GraficoRegistrosPonto",
            prefix: "mdi-chart-bar",
            link: "/dashboard/relatorios/funcionarioregistrosponto",
            can: "ROLE_FuncionarioPonto_List",
          },
          {
            title: "Relatorio_registros_duplicados",
            prefix: "mdi-content-duplicate",
            link: "/dashboard/relatorios/registrosDuplicados",
            can: "ROLE_FuncionarioPonto_List",
          },
          {
            title: "Dashboard_de_absenteismo",
            prefix: "mdi-chart-bar",
            link: "/dashboard/relatorios/absenteismo",
            can: "ROLE_FuncionarioPonto_List",
          },
          {
            title: "Relatorio_registros_fora_tolerancia",
            prefix: "mdi-chart-bar",
            link: "/dashboard/relatorios/registrosForaTolerancia",
            can: "ROLE_FuncionarioPonto_List",
          },
          {
            title: "Auditoria_local_registros_de_ponto",
            prefix: "mdi-chart-bar",
            link: "/dashboard/relatorios/auditoriaLocalRegistrosPonto",
            can: "ROLE_FuncionarioPonto_List",
          },
          {
            title: "Ausencia_registros_ponto",
            prefix: "mdi-account-clock-outline",
            link: "/dashboard/relatorios/ausenciaRegistrosPonto",
            can: "ROLE_FuncionarioPonto_List",
          },
          {
            title: "Ocorrencias_apuracao_ponto",
            prefix: "mdi-clipboard-alert-outline",
            link: "/dashboard/relatorios/ocorrenciasApuracaoPonto",
            can: "ROLE_FuncionarioPontoCalculo_List",
          },
          {
            title: "Presenca_ausencia_ponto",
            prefix: "mdi-account-check-outline",
            link: "/dashboard/relatorios/presencaAusenciaPonto",
            can: "ROLE_FuncionarioPonto_List",
          },
          {
            title: "Horas_apuradas_ponto",
            prefix: "mdi-clock-check-outline",
            link: "/dashboard/relatorios/horasApuradasPonto",
            can: "ROLE_FuncionarioPontoCalculo_List",
          },
          {
            title: "Registros_por_equipamento_ponto",
            prefix: "mdi-devices",
            link: "/dashboard/relatorios/registrosPorEquipamento",
            can: "ROLE_FuncionarioPonto_List",
          },

          {
            title: "FuncionarioPontoPeriodoReducaoCargaHorariaColetiva",
            prefix: "mdi-clock-alert-outline",
            link: "/dashboard/funcionarioPontoPeriodoReducaoCargaHorariaColetiva",
            can: "ROLE_FuncionarioPontoPeriodoReducaoCargaHorariaColetiva_List",
          },
          {
            title: "FolgaBonusRegras",
            prefix: "mdi-gift-outline",
            link: "/dashboard/folgaBonusRegras",
            can: "ROLE_FolgaBonusRegra_List",
          },
          {
            title: "FolgaBonusApuracao",
            prefix: "mdi-calendar-star",
            link: "/dashboard/folgaBonusApuracao",
            can: "ROLE_FolgaBonusConcessao_List",
          },
          {
            title: "FuncionarioPontoNotificacoes",
            prefix: "mdi-bell-cog-outline",
            link: "/dashboard/funcionarioPontoNotificacoes",
            can: "ROLE_FuncionarioPontoNotificacao_List",
          },
          {
            title: "GAH",
            prefix: "mdi-clock-alert-outline",
            link: "/dashboard/gestaoAcademicaHorarios",
            can: "ROLE_Funcionario_EscalaDocente",
          },

          {
            title: "Monitoramento_registradores_externos",
            prefix: "mdi-chart-bar",
            link: "/dashboard/relatorios/monitoramentoRegistradoresExternos",
            can: "ROLE_RegistradorPontoExterno_List",
          },

          {
            title: "RegistradorPontoExterno",
            prefix: "mdi-chart-bar",
            link: "/dashboard/registradorPontoExterno",
            can: "ROLE_RegistradorPontoExterno_List",
          },
          {
            title: "FuncionarioRegistrador",
            prefix: "mdi-clock-alert-outline",
            link: "/dashboard/funcionarioRegistrador",
            can: "ROLE_FuncionarioRegistrador_List",
          },
          {
            title: "FuncionarioPontoWeb",
            prefix: "mdi-monitor-account",
            link: "/dashboard/funcionarioPontoWeb",
            can: "ROLE_FuncionarioPontoWeb_List",
          },
        ],
      },

      // {
      //   title: "CRP_Coletor_Remoto_Ponto",
      //   active: false,
      //   action:
      //     '<svg width="12px" height="12px" viewBox="0 0 40 44" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>document</title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1870.000000, -591.000000)" fill="#FFFFFF" fill-rule="nonzero"><g transform="translate(1716.000000, 291.000000)"><g transform="translate(154.000000, 300.000000)"><path class="color-background" d="M40,40 L36.3636364,40 L36.3636364,3.63636364 L5.45454545,3.63636364 L5.45454545,0 L38.1818182,0 C39.1854545,0 40,0.814545455 40,1.81818182 L40,40 Z" opacity="0.603585379"></path><path class="color-background" d="M30.9090909,7.27272727 L1.81818182,7.27272727 C0.814545455,7.27272727 0,8.08727273 0,9.09090909 L0,41.8181818 C0,42.8218182 0.814545455,43.6363636 1.81818182,43.6363636 L30.9090909,43.6363636 C31.9127273,43.6363636 32.7272727,42.8218182 32.7272727,41.8181818 L32.7272727,9.09090909 C32.7272727,8.08727273 31.9127273,7.27272727 30.9090909,7.27272727 Z M18.1818182,34.5454545 L7.27272727,34.5454545 L7.27272727,30.9090909 L18.1818182,30.9090909 L18.1818182,34.5454545 Z M25.4545455,27.2727273 L7.27272727,27.2727273 L7.27272727,23.6363636 L25.4545455,23.6363636 L25.4545455,27.2727273 Z M25.4545455,20 L7.27272727,20 L7.27272727,16.3636364 L25.4545455,16.3636364 L25.4545455,20 Z"></path></g></g></g></g></svg>',
      //   group: "ponto",
      //   can: "ROLE_MENU_Ponto",
      //   prefix: "mdi-devices",
      //   items: [
      //     {
      //       title: "Registros_de_ponto",
      //       prefix: "mdi-account-clock-outline",
      //       link: "/dashboard/funcionariopontos",
      //       can: "ROLE_FuncionarioPonto_List",
      //     },
      //   ],
      // },

      // {
      //   title: "GCD_Gestao_Contratação_Documentos",
      //   active: false,
      //   action:
      //     '<svg width="12px" height="12px" viewBox="0 0 40 44" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>document</title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1870.000000, -591.000000)" fill="#FFFFFF" fill-rule="nonzero"><g transform="translate(1716.000000, 291.000000)"><g transform="translate(154.000000, 300.000000)"><path class="color-background" d="M40,40 L36.3636364,40 L36.3636364,3.63636364 L5.45454545,3.63636364 L5.45454545,0 L38.1818182,0 C39.1854545,0 40,0.814545455 40,1.81818182 L40,40 Z" opacity="0.603585379"></path><path class="color-background" d="M30.9090909,7.27272727 L1.81818182,7.27272727 C0.814545455,7.27272727 0,8.08727273 0,9.09090909 L0,41.8181818 C0,42.8218182 0.814545455,43.6363636 1.81818182,43.6363636 L30.9090909,43.6363636 C31.9127273,43.6363636 32.7272727,42.8218182 32.7272727,41.8181818 L32.7272727,9.09090909 C32.7272727,8.08727273 31.9127273,7.27272727 30.9090909,7.27272727 Z M18.1818182,34.5454545 L7.27272727,34.5454545 L7.27272727,30.9090909 L18.1818182,30.9090909 L18.1818182,34.5454545 Z M25.4545455,27.2727273 L7.27272727,27.2727273 L7.27272727,23.6363636 L25.4545455,23.6363636 L25.4545455,27.2727273 Z M25.4545455,20 L7.27272727,20 L7.27272727,16.3636364 L25.4545455,16.3636364 L25.4545455,20 Z"></path></g></g></g></g></svg>',
      //   group: "pessoal",
      //   can: "ROLE_MENU_Pessoal",
      //   prefix: "mdi-devices",
      //   items: [
      //     {
      //       title: "ModeloDocumentacaoAcessoria",
      //       prefix: "mdi-file-sign",
      //       link: "/dashboard/modeloDocumentacaoAcessorias",
      //       can: "ROLE_ModeloDocumentacaoAcessoria_List",
      //     },
      //   ],
      // },

      {
        title: "GestaoTarefasDiarias",
        active: false,
        action:
          '<svg width="12px" height="12px" viewBox="0 0 40 44" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>document</title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1870.000000, -591.000000)" fill="#FFFFFF" fill-rule="nonzero"><g transform="translate(1716.000000, 291.000000)"><g transform="translate(154.000000, 300.000000)"><path class="color-background" d="M40,40 L36.3636364,40 L36.3636364,3.63636364 L5.45454545,3.63636364 L5.45454545,0 L38.1818182,0 C39.1854545,0 40,0.814545455 40,1.81818182 L40,40 Z" opacity="0.603585379"></path><path class="color-background" d="M30.9090909,7.27272727 L1.81818182,7.27272727 C0.814545455,7.27272727 0,8.08727273 0,9.09090909 L0,41.8181818 C0,42.8218182 0.814545455,43.6363636 1.81818182,43.6363636 L30.9090909,43.6363636 C31.9127273,43.6363636 32.7272727,42.8218182 32.7272727,41.8181818 L32.7272727,9.09090909 C32.7272727,8.08727273 31.9127273,7.27272727 30.9090909,7.27272727 Z M18.1818182,34.5454545 L7.27272727,34.5454545 L7.27272727,30.9090909 L18.1818182,30.9090909 L18.1818182,34.5454545 Z M25.4545455,27.2727273 L7.27272727,27.2727273 L7.27272727,23.6363636 L25.4545455,23.6363636 L25.4545455,27.2727273 Z M25.4545455,20 L7.27272727,20 L7.27272727,16.3636364 L25.4545455,16.3636364 L25.4545455,20 Z"></path></g></g></g></g></svg>',
        group: "GestaoTarefasDiarias",
        can: "ROLE_MENU_GestaoTarefasDiarias",
        prefix: "mdi-devices",
        items: [
          {
            title: "registrotarefaperiodo",
            prefix: "mdi-map-clock-outline",
            link: "/dashboard/registrotarefaperiodos",
            can: "ROLE_RegistroTarefaPeriodo_List",
          },
          {
            title: "registrotarefacalculo",
            prefix: "mdi-map-clock-outline",
            link: "/dashboard/registrotarefacalculo",
            can: "ROLE_RegistroTarefaCalculo_List",
          },
        ],
      },

      // {
      //   title: "GEF_Gestao_Efetivo",
      //   active: false,
      //   action:
      //     '<svg width="12px" height="12px" viewBox="0 0 46 42" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>customer-support</title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1717.000000, -291.000000)" fill="#FFFFFF" fill-rule="nonzero"><g transform="translate(1716.000000, 291.000000)"><g transform="translate(1.000000, 0.000000)"><path class="color-background" d="M45,0 L26,0 C25.447,0 25,0.447 25,1 L25,20 C25,20.379 25.214,20.725 25.553,20.895 C25.694,20.965 25.848,21 26,21 C26.212,21 26.424,20.933 26.6,20.8 L34.333,15 L45,15 C45.553,15 46,14.553 46,14 L46,1 C46,0.447 45.553,0 45,0 Z" opacity="0.59858631"></path><path class="color-background" d="M22.883,32.86 C20.761,32.012 17.324,31 13,31 C8.676,31 5.239,32.012 3.116,32.86 C1.224,33.619 0,35.438 0,37.494 L0,41 C0,41.553 0.447,42 1,42 L25,42 C25.553,42 26,41.553 26,41 L26,37.494 C26,35.438 24.776,33.619 22.883,32.86 Z"></path><path class="color-background" d="M13,28 C17.432,28 21,22.529 21,18 C21,13.589 17.411,10 13,10 C8.589,10 5,13.589 5,18 C5,22.529 8.568,28 13,28 Z"></path></g></g></g></g></svg>',
      //   group: "pessoal",
      //   can: "ROLE_MENU_Pessoal",
      //   prefix: "mdi-devices",
      //   items: [
      //     {
      //       title: "gestaoEfetivo",
      //       prefix: "mdi-account-multiple-check",
      //       link: "/dashboard/gestaoEfetivo",
      //       can: "ROLE_GestaoEfetivo_List",
      //     },
      //   ],
      // },

      {
        title: "Comercial",
        active: false,
        action:
          '<svg width="12px" height="12px" viewBox="0 0 45 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>shop </title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1716.000000, -439.000000)" fill="#FFFFFF" fill-rule="nonzero"><g transform="translate(1716.000000, 291.000000)"><g transform="translate(0.000000, 148.000000)"><path class="color-background" d="M46.7199583,10.7414583 L40.8449583,0.949791667 C40.4909749,0.360605034 39.8540131,0 39.1666667,0 L7.83333333,0 C7.1459869,0 6.50902508,0.360605034 6.15504167,0.949791667 L0.280041667,10.7414583 C0.0969176761,11.0460037 -1.23209662e-05,11.3946378 -1.23209662e-05,11.75 C-0.00758042603,16.0663731 3.48367543,19.5725301 7.80004167,19.5833333 L7.81570833,19.5833333 C9.75003686,19.5882688 11.6168794,18.8726691 13.0522917,17.5760417 C16.0171492,20.2556967 20.5292675,20.2556967 23.494125,17.5760417 C26.4604562,20.2616016 30.9794188,20.2616016 33.94575,17.5760417 C36.2421905,19.6477597 39.5441143,20.1708521 42.3684437,18.9103691 C45.1927731,17.649886 47.0084685,14.8428276 47.0000295,11.75 C47.0000295,11.3946378 46.9030823,11.0460037 46.7199583,10.7414583 Z" opacity="0.598981585"></path><path class="color-background" d="M39.198,22.4912623 C37.3776246,22.4928106 35.5817531,22.0149171 33.951625,21.0951667 L33.92225,21.1107282 C31.1430221,22.6838032 27.9255001,22.9318916 24.9844167,21.7998837 C24.4750389,21.605469 23.9777983,21.3722567 23.4960833,21.1018359 L23.4745417,21.1129513 C20.6961809,22.6871153 17.4786145,22.9344611 14.5386667,21.7998837 C14.029926,21.6054643 13.533337,21.3722507 13.0522917,21.1018359 C11.4250962,22.0190609 9.63246555,22.4947009 7.81570833,22.4912623 C7.16510551,22.4842162 6.51607673,22.4173045 5.875,22.2911849 L5.875,44.7220845 C5.875,45.9498589 6.7517757,46.9451667 7.83333333,46.9451667 L19.5833333,46.9451667 L19.5833333,33.6066734 L27.4166667,33.6066734 L27.4166667,46.9451667 L39.1666667,46.9451667 C40.2482243,46.9451667 41.125,45.9498589 41.125,44.7220845 L41.125,22.2822926 C40.4887822,22.4116582 39.8442868,22.4815492 39.198,22.4912623 Z"></path></g></g></g></g></svg>',
        group: "clientes",
        can: "ROLE_MENU_Comercial",
        prefix: "mdi-handshake-outline",
        items: [
          {
            title: "Clientes" /*titulo*/,
            prefix: "mdi-account-switch" /*ícone*/,
            link: "/dashboard/clientes" /*Href*/,
            can: "ROLE_Cliente_List" /*Can*/,
          },
          {
            title: "ClienteEnderecoClassificacoes",
            prefix: "mdi-map-marker-star-outline",
            link: "/dashboard/clienteEnderecoClassificacoes",
            can: "ROLE_ClienteEnderecoClassificacao_List",
            modulo: "TRANSPORTEVALORES",
          },
          {
            title: "Cfops" /*titulo*/,
            prefix: "mdi-file" /*ícone*/,
            link: "/dashboard/cfops" /*Href*/,
            can: "ROLE_Cfop_List" /*Can*/,
          },
          {
            title: "CfopCidades" /*titulo*/,
            prefix: "mdi-map" /*ícone*/,
            link: "/dashboard/cfopCidades" /*Href*/,
            can: "ROLE_CfopCidade_List" /*Can*/,
          },
          {
            title: "CfopEstados" /*titulo*/,
            prefix: "mdi-map-marker" /*ícone*/,
            link: "/dashboard/cfopEstados" /*Href*/,
            can: "ROLE_CfopEstado_List" /*Can*/,
          },
          {
            title: "ParametrizacaoFiscal" /*titulo*/,
            prefix: "mdi-book" /*ícone*/,
            link: "/dashboard/parametrizacaoFiscal" /*Href*/,
            can: "ROLE_ParametrizacaoFiscal_List" /*Can*/,
          },

          {
            title: "Contratos" /*titulo*/,
            prefix: "mdi-file-document-edit-outline" /*ícone*/,
            link: "/dashboard/contratos" /*Href*/,
            can: "ROLE_Contrato_List" /*Can*/,
          },
          {
            title: "ConcomitanciasTransporte",
            prefix: "mdi-map-marker-multiple",
            link: "/dashboard/concomitanciasTransporte",
            can: "ROLE_ConcomitanciaTransporte_List",
          },
          {
            title: "EscopoServicos" /*titulo*/,
            prefix: "mdi-nas" /*ícone*/,
            link: "/dashboard/escopoServicos" /*Href*/,
            can: "ROLE_EscopoServico_List" /*Can*/,
          },
          {
            title: "ParametrizacaoServicos" /*titulo*/,
            prefix: "mdi-file-cog" /*ícone*/,
            link: "/dashboard/parametrizacaoServicos" /*Href*/,
            can: "ROLE_ParametrizacaoServico_List" /*Can*/,
          },
          {
            title: "PostoTrabalhos" /*titulo*/,
            prefix: "mdi-book-marker-outline" /*ícone*/,
            link: "/dashboard/postoTrabalhos" /*Href*/,
            can: "ROLE_PostoTrabalho_List" /*Can*/,
          },
          {
            title: "ReajustesContratuais" /*titulo*/,
            prefix: "mdi-file-document-edit-outline" /*ícone*/,
            link: "/dashboard/reajustesContratuais" /*Href*/,
            can: "ROLE_ReajusteContratual_List" /*Can*/,
          },
          {
            title: "Certidoes" /*titulo*/,
            prefix: "mdi-file-certificate-outline" /*ícone*/,
            link: "/dashboard/certidoes" /*Href*/,
            can: "ROLE_Certidao_List" /*Can*/,
            modulo: "GESTAOCERTIDOES",
          },
        ],
      },

      {
        title: "GAP",
        active: false,
        action:
          '<svg width="12px" height="12px" viewBox="0 0 40 44" version="1.1" xmlns="http://www.w3.org/2000/svg"><title>document</title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g fill="#FFFFFF" fill-rule="nonzero"><path class="color-background" d="M8,0 L25,0 L40,15 L40,40 C40,42.209 38.209,44 36,44 L8,44 C5.791,44 4,42.209 4,40 L4,4 C4,1.791 5.791,0 8,0 Z" opacity="0.603585379"></path><path class="color-background" d="M25,0 L25,12 C25,13.657 26.343,15 28,15 L40,15 Z"></path><path class="color-background" d="M12,24 L32,24 L32,28 L12,28 Z M12,32 L28,32 L28,36 L12,36 Z"></path></g></g></svg>',
        group: "gap",
        can: "ROLE_MENU_GAP",
        prefix: "mdi-file-sign",
        items: [
          {
            title: "PropostaComercial" /*titulo*/,
            prefix: "mdi-file-sign" /*ícone*/,
            link: "/dashboard/propostaComercial" /*Href*/,
            can: "ROLE_PropostaComercial_List" /*Can*/,
          },
          {
            title: "DashboardPropostaComercial" /*titulo*/,
            prefix: "mdi-chart-box-outline" /*ícone*/,
            link: "/dashboard/propostaComercial/painel" /*Href*/,
            can: "ROLE_PropostaComercial_Dashboard" /*Can*/,
          },
          {
            title: "ModeloPropostaComercial" /*titulo*/,
            prefix: "mdi-file-code-outline" /*ícone*/,
            link: "/dashboard/modeloPropostaComercial" /*Href*/,
            can: "ROLE_ModeloPropostaComercial_List" /*Can*/,
          },
        ],
      },

      {
        title: "Pessoal",
        active: false,
        action:
          '<svg width="12px" height="12px" viewBox="0 0 46 42" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>customer-support</title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1717.000000, -291.000000)" fill="#FFFFFF" fill-rule="nonzero"><g transform="translate(1716.000000, 291.000000)"><g transform="translate(1.000000, 0.000000)"><path class="color-background" d="M45,0 L26,0 C25.447,0 25,0.447 25,1 L25,20 C25,20.379 25.214,20.725 25.553,20.895 C25.694,20.965 25.848,21 26,21 C26.212,21 26.424,20.933 26.6,20.8 L34.333,15 L45,15 C45.553,15 46,14.553 46,14 L46,1 C46,0.447 45.553,0 45,0 Z" opacity="0.59858631"></path><path class="color-background" d="M22.883,32.86 C20.761,32.012 17.324,31 13,31 C8.676,31 5.239,32.012 3.116,32.86 C1.224,33.619 0,35.438 0,37.494 L0,41 C0,41.553 0.447,42 1,42 L25,42 C25.553,42 26,41.553 26,41 L26,37.494 C26,35.438 24.776,33.619 22.883,32.86 Z"></path><path class="color-background" d="M13,28 C17.432,28 21,22.529 21,18 C21,13.589 17.411,10 13,10 C8.589,10 5,13.589 5,18 C5,22.529 8.568,28 13,28 Z"></path></g></g></g></g></svg>',
        group: "pessoal",
        prefix: "mdi-account-group",
        can: "ROLE_MENU_Pessoal",
        items: [
          {
            title: "Funcionarios",
            prefix: "mdi-account-hard-hat",
            link: "/dashboard/funcionarios",
            can: "ROLE_Funcionario_List",
          },
          {
            title: "FuncionarioContratacoesDesligamentosPeriodo",
            prefix: "mdi-file-chart-outline",
            link: "/dashboard/funcionarios/contratacoesDesligamentosPeriodo",
            can: "ROLE_Funcionario_List",
          },
          {
            title: "Rotatividade_admissional_demissional",
            prefix: "mdi-chart-timeline-variant",
            link: "/dashboard/funcionarios/rotatividadeAdmissionalDemissional",
            can: "ROLE_Funcionario_List",
          },
          {
            title: "QuadroFuncionarios",
            prefix: "mdi-file-sign",
            link: "/dashboard/funcionarios/quadroFuncionarios",
            can: "ROLE_Funcionario_List",
          },
          {
            title: "AnalisePeriodoExperiencia",
            prefix: "mdi-account-clock-outline",
            link: "/dashboard/funcionarios/periodoExperiencia",
            can: "ROLE_Funcionario_List",
          },
          {
            title: "AnaliseValidadeCursos",
            prefix: "mdi-card-account-details-star-outline",
            link: "/dashboard/funcionarios/validadeCursos",
            can: "ROLE_Funcionario_List",
          },
          {
            title: "AnaliseDesligamentos",
            prefix: "mdi-account-arrow-left-outline",
            link: "/dashboard/funcionarios/desligamentos",
            can: "ROLE_Funcionario_List",
          },
          {
            title: "Relatorio_aniversariantes_periodo",
            prefix: "mdi-chart-bar",
            link: "/dashboard/relatorios/aniversariantesPeriodo",
            can: "ROLE_FuncionarioPonto_List",
          },
          {
            title: "Relatorio_funcionarios_multiplos_contratos",
            prefix: "mdi-chart-bar",
            link: "/dashboard/relatorios/funcionariosMultiplosContratos",
            can: "ROLE_FuncionarioPonto_List",
          },
          {
            title: "gestaoEfetivo",
            prefix: "mdi-account-multiple-check",
            link: "/dashboard/gestaoEfetivo",
            can: "ROLE_GestaoEfetivo_List",
          },
          {
            title: "centroComandoOperacional",
            prefix: "mdi-radar",
            link: "/dashboard/gestaoEfetivo/centroComandoOperacional",
            can: "ROLE_GestaoEfetivo_List",
          },
          {
            title: "gestaoEfetivoAnalise",
            prefix: "mdi-chart-box",
            link: "/dashboard/gestaoEfetivo/analise",
            can: "ROLE_GestaoEfetivo_List",
          },
          {
            title: "PostoTrabalhoOcorrencias" /*titulo*/,
            prefix: "mdi-book-marker-outline" /*ícone*/,
            link: "/dashboard/postoTrabalhoOcorrencias" /*Href*/,
            can: "ROLE_PostoTrabalhoOcorrencia_List" /*Can*/,
          },
          {
            title: "Funcionario_movimentacoes",
            prefix: "mdi-transit-connection-variant",
            link: "/dashboard/funcionarioMovimentacoes",
            can: "ROLE_FuncionarioMovimentacoes_List",
          },
          {
            title: "Pessoas",
            prefix: "mdi-account-supervisor-circle",
            link: "/dashboard/pessoas",
            can: "ROLE_Pessoa_List",
          },
          {
            title: "FuncionarioAfastamentoTipo",
            prefix: "mdi-format-list-bulleted-type",
            link: "/dashboard/funcionarioAfastamentoTipos",
            can: "ROLE_FuncionarioAfastamentoTipo_List",
          },
          {
            title: "AfastamentoSolicitacoes",
            prefix: "mdi-account-cancel-outline",
            link: "/dashboard/funcionarioAfastamentoSolicitacoes",
            can: "ROLE_FuncionarioAfastamentoSolicitacao_List",
          },
          {
            title: "Afastamentos",
            prefix: "mdi-account-cancel-outline",
            link: "/dashboard/funcionarioAfastamentos",
            can: "ROLE_FuncionarioAfastamento_List",
          },
          {
            title: "Medicos",
            prefix: "mdi-stethoscope",
            link: "/dashboard/medicos",
            can: "ROLE_Medico_List",
          },
          {
            title: "FuncionarioBancoHoras",
            prefix: "mdi-database-clock-outline",
            link: "/dashboard/FuncionarioBancoHorasContratos",
            can: "ROLE_FuncionarioBancoHorasContrato_List",
          },

          {
            title: "FuncionarioCargo",
            prefix: "mdi-account-cog",
            link: "/dashboard/funcionariocargos",
            can: "ROLE_FuncionarioCargo_List",
          },
          {
            title: "FuncionarioSindicato",
            prefix: "mdi-card-account-details-star",
            link: "/dashboard/funcionariosindicatos",
            can: "ROLE_FuncionarioSindicato_List",
          },
          {
            title: "Escala_de_trabalho",
            prefix: "mdi-file-clock",
            link: "/dashboard/funcionarioEscalaTrabalhos",
            can: "ROLE_FuncionarioEscalaTrabalho_List",
          },

          {
            title: "PeriodoFolhaPagamento",
            prefix: "mdi-map-clock-outline",
            link: "/dashboard/funcionarioFolhaPagamentoPeriodos",
            can: "ROLE_FuncionarioFolhaPagamentoPeriodo_List",
          },
          {
            title: "FuncionarioFolhaPagamentos",
            prefix: "mdi-text-box-search-outline",
            link: "/dashboard/FuncionarioFolhaPagamentos",
            can: "ROLE_FuncionarioFolhaPagamento_List",
          },
          {
            title: "DashboardFolhaPagamento",
            prefix: "mdi-chart-box-outline",
            link: "/dashboard/relatorios/dashboardFolhaPagamento",
            can: "ROLE_FuncionarioFolhaPagamento_List",
          },

          {
            title: "FuncionarioFolhaPagamentoVerbas",
            prefix: "mdi-cash-marker",
            link: "/dashboard/funcionarioFolhaPagamentoVerbas",
            can: "ROLE_FuncionarioFolhaPagamentoVerba_List",
          },

          {
            title: "AvisoPrevio",
            prefix: "mdi-account-clock-outline",
            link: "/dashboard/funcionarioavisoprevios",
            can: "ROLE_FuncionarioAvisoPrevio_List",
          },
          {
            title: "ModeloDocumentacaoAcessoria",
            prefix: "mdi-file-sign",
            link: "/dashboard/modeloDocumentacaoAcessorias",
            can: "ROLE_ModeloDocumentacaoAcessoria_List",
          },
          {
            title: "FuncionarioDocumentacaoAcessoria",
            prefix: "mdi-file-sign",
            link: "/dashboard/funcionarioDocumentacaoAcessoria",
            can: "ROLE_FuncionarioDocumentacaoAcessoria_List",
          },
          {
            title: "ComunicacaoInterna",
            prefix: "mdi-file-sign",
            link: "/dashboard/comunicacaoInterna",
            can: "ROLE_ComunicacaoInterna_List",
          },
          {
            title: "IntegracaoExternaHistorico",
            prefix: "mdi-history",
            link: "/dashboard/integracoesExternas",
            can: "ROLE_Funcionario_List",
          },
          // {
          //   title: "FuncionarioIntegracaoExterna",
          //   prefix: "mdi-transit-connection-variant",
          //   link: "/dashboard/funcionarios/integracaoExterna",
          //   can: "ROLE_Funcionario_List",
          // },
        ],
      },
      {
        title: "CFP",
        active: false,
        action:
          '<svg width="12px" height="12px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path class="color-background" fill="#FFFFFF" d="M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zM7 7h10v2H7zm0 4h2v2H7zm0 4h2v2H7zm4-4h2v2h-2zm0 4h2v2h-2zm4-4h2v6h-2z"/></svg>',
        group: "folhaCalculo",
        can: "ROLE_MENU_FolhaCalculo",
        prefix: "mdi-calculator-variant-outline",
        hideWhenEmpty: true,
        items: [
          {
            title: "FolhaCalculoFolhas",
            prefix: "mdi-calculator-variant-outline",
            link: "/dashboard/folhaCalculo/folhas",
            can: "ROLE_MENU_FolhaCalculo",
          },
          {
            title: "FuncionarioFolhaPagamentoVerbas",
            prefix: "mdi-cash-marker",
            link: "/dashboard/funcionarioFolhaPagamentoVerbas",
            can: "ROLE_FuncionarioFolhaPagamentoVerba_List",
          },
          {
            title: "FolhaCalculoConfiguracao",
            prefix: "mdi-cog-outline",
            link: "/dashboard/folhaCalculo/configuracao",
            can: "ROLE_FolhaConfiguracao_Update",
          },
          {
            title: "FolhaCalculoTabelas",
            prefix: "mdi-scale-balance",
            link: "/dashboard/folhaCalculo/tabelas",
            can: "ROLE_FolhaTabelaLegal_List",
          },
        ],
      },
      {
        title: "ESocial",
        active: false,
        action:
          '<svg width="12px" height="12px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path class="color-background" fill="#FFFFFF" d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8zm0 2 4 4h-4zM9 11l1.4 1.4L7.8 15l2.6 2.6L9 19l-4-4zm6 0 4 4-4 4-1.4-1.4 2.6-2.6-2.6-2.6z"/></svg>',
        group: "esocial",
        can: "ROLE_MENU_ESocial",
        prefix: "mdi-file-xml-box",
        hideWhenEmpty: true,
        items: [
          {
            title: "ESocialImportacaoManual",
            prefix: "mdi-file-upload-outline",
            link: "/dashboard/esocialImportacao/manual",
            can: "ROLE_MENU_ESocial_ImportacaoManual",
          },
          {
            title: "ESocialImportacaoConfiguracao",
            prefix: "mdi-cog-outline",
            link: "/dashboard/esocialImportacao/configuracao",
            can: "ROLE_MENU_ESocial_Configuracao",
          },
          {
            title: "ESocialImportacaoAcompanhamento",
            prefix: "mdi-clipboard-text-search-outline",
            link: "/dashboard/esocialImportacao/acompanhamento",
            can: "ROLE_MENU_ESocial_Acompanhamento",
          },
          {
            title: "ESocialEnvioAcompanhamento",
            prefix: "mdi-send-check-outline",
            link: "/dashboard/esocialImportacao/envio",
            can: "ROLE_MENU_ESocial_Envio",
          },
          {
            title: "ESocialTabelas",
            prefix: "mdi-table-cog",
            link: "/dashboard/esocialImportacao/tabelas",
            can: "ROLE_MENU_ESocial_Envio",
            requiresEsocialEnvio: true,
          },
        ],
      },
      {
        title: "GESTAOFERIAS_menu",
        active: false,
        action:
          '<svg width="12px" height="12px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path class="color-background" fill="#FFFFFF" d="M19 4h-1V2h-2v2H8V2H6v2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 16H5V9h14zM7 11h5v5H7z"/></svg>',
        group: "GESTAOFERIAS",
        prefix: "mdi-beach",
        can: "ROLE_MENU_GestaoFerias",
        items: [
          {
            title: "FuncionarioPeriodosAquisitivos",
            prefix: "mdi-calendar-range",
            link: "/dashboard/funcionarioPeriodosAquisitivos",
            can: "ROLE_FuncionarioPeriodoAquisitivo_List",
          },
          {
            title: "DashboardFeriasPeriodosAquisitivos",
            prefix: "mdi-timer-sand",
            link: "/dashboard/relatorios/feriasPeriodosAquisitivos",
            can: "ROLE_FuncionarioPeriodoAquisitivoDashboard_List",
          },
          {
            title: "DashboardProgramacaoFerias",
            prefix: "mdi-calendar-month-outline",
            link: "/dashboard/relatorios/programacaoFerias",
            can: "ROLE_FuncionarioPeriodoAquisitivoDashboard_List",
          },
        ],
      },
      {
        title: "CLP",
        active: false,
        action:
          '<svg width="12" height="12" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path class="color-background" fill="#FFFFFF" d="M3 3h18v4H3zM5 9h3v9H5zm5 0h4v9h-4zm6 0h3v9h-3zM3 20h18v2H3z"/></svg>',
        group: "CLP",
        prefix: "mdi-bank-outline",
        can: "ROLE_OportunidadePublica_List",
        items: [
          {
            title: "OportunidadesPublicas",
            prefix: "mdi-briefcase-search-outline",
            link: "/dashboard/oportunidadesPublicas",
            can: "ROLE_OportunidadePublica_List",
          },
          {
            title: "RotinasInternas",
            prefix: "mdi-view-column-outline",
            link: "/dashboard/rotinasInternas",
            can: "ROLE_RotinaInterna_List",
          },
          {
            title: "Certidoes" /*titulo*/,
            prefix: "mdi-file-certificate-outline" /*ícone*/,
            link: "/dashboard/certidoes" /*Href*/,
            can: "ROLE_Certidao_List" /*Can*/,
            modulo: "GESTAOCERTIDOES",
          },
        ],
      },
      {
        title: "GCT",
        active: false,
        action:
          '<svg width="12px" height="12px" viewBox="0 0 42 42" version="1.1" xmlns="http://www.w3.org/2000/svg"><title>briefcase</title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g fill="#FFFFFF" fill-rule="nonzero"><path class="color-background" d="M15,6 C15,4.343 16.343,3 18,3 L24,3 C25.657,3 27,4.343 27,6 L27,9 L23.5,9 L23.5,6.5 L18.5,6.5 L18.5,9 L15,9 L15,6 Z" opacity="0.59858631"></path><path class="color-background" d="M38,11 L4,11 C2.343,11 1,12.343 1,14 L1,22 C1,23.105 1.895,24 3,24 L18,24 L18,22 C18,21.448 18.448,21 19,21 L23,21 C23.552,21 24,21.448 24,22 L24,24 L39,24 C40.105,24 41,23.105 41,22 L41,14 C41,12.343 39.657,11 38,11 Z"></path><path class="color-background" d="M24,28 C24,28.552 23.552,29 23,29 L19,29 C18.448,29 18,28.552 18,28 L18,27 L2,27 L2,36 C2,37.657 3.343,39 5,39 L37,39 C38.657,39 40,37.657 40,36 L40,27 L24,27 L24,28 Z" opacity="0.59858631"></path></g></g></svg>',
        group: "GCT",
        prefix: "mdi-briefcase-account-outline",
        can: "ROLE_MENU_GestaoContratacao",
        items: [
          {
            title: "GestaoContratacao",
            prefix: "mdi-briefcase-search-outline",
            link: "/dashboard/gestaoContratacao",
            can: "ROLE_RecrutamentoVaga_List",
          },
          {
            title: "RecrutamentoBancoTalentos",
            prefix: "mdi-account-box-multiple-outline",
            link: "/dashboard/gestaoContratacao/bancoTalentos",
            can: "ROLE_RecrutamentoBancoTalentos_List",
          },
          {
            title: "GestaoContratacaoDashboard",
            prefix: "mdi-chart-box-outline",
            link: "/dashboard/gestaoContratacao/dashboard",
            can: "ROLE_RecrutamentoDashboard_List",
          },
          {
            title: "RecrutamentoDashboardEntrevistas",
            prefix: "mdi-account-voice",
            link: "/dashboard/gestaoContratacao/dashboardEntrevistas",
            can: "ROLE_RecrutamentoDashboardEntrevistas_List",
          },
          {
            title: "RecrutamentoDashboardBancoTalentos",
            prefix: "mdi-chart-donut",
            link: "/dashboard/gestaoContratacao/dashboardBancoTalentos",
            can: "ROLE_RecrutamentoDashboardBancoTalentos_List",
          },
          {
            title: "RecrutamentoSolicitacoes",
            prefix: "mdi-clipboard-text-clock-outline",
            link: "/dashboard/recrutamentoSolicitacoes",
            can: "ROLE_RecrutamentoSolicitacao_List",
          },
        ],
      },
      {
        title: "PRECONTRATACAO",
        active: false,
        action:
          '<svg width="12px" height="12px" viewBox="0 0 46 42" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>customer-support</title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1717.000000, -291.000000)" fill="#FFFFFF" fill-rule="nonzero"><g transform="translate(1716.000000, 291.000000)"><g transform="translate(1.000000, 0.000000)"><path class="color-background" d="M45,0 L26,0 C25.447,0 25,0.447 25,1 L25,20 C25,20.379 25.214,20.725 25.553,20.895 C25.694,20.965 25.848,21 26,21 C26.212,21 26.424,20.933 26.6,20.8 L34.333,15 L45,15 C45.553,15 46,14.553 46,14 L46,1 C46,0.447 45.553,0 45,0 Z" opacity="0.59858631"></path><path class="color-background" d="M22.883,32.86 C20.761,32.012 17.324,31 13,31 C8.676,31 5.239,32.012 3.116,32.86 C1.224,33.619 0,35.438 0,37.494 L0,41 C0,41.553 0.447,42 1,42 L25,42 C25.553,42 26,41.553 26,41 L26,37.494 C26,35.438 24.776,33.619 22.883,32.86 Z"></path><path class="color-background" d="M13,28 C17.432,28 21,22.529 21,18 C21,13.589 17.411,10 13,10 C8.589,10 5,13.589 5,18 C5,22.529 8.568,28 13,28 Z"></path></g></g></g></g></svg>',
        group: "PRECONTRATACAO",
        prefix: "mdi-account-group",
        can: "ROLE_MENU_PreContratacao",
        items: [
          {
            title: "FuncionarioPreContratracaoDocumentos",
            prefix: "mdi-file-document-outline",
            link: "/dashboard/funcionarioPreContratracaoDocumentos",
            can: "ROLE_FuncionarioPreContratracaoDocumentos_List",
          },
          {
            title: "FuncionarioPreContratracao",
            prefix: "mdi-account-plus-outline",
            link: "/dashboard/funcionarioPreContratracao",
            can: "ROLE_FuncionarioPreContratracao_List",
          },
          {
            title: "FuncionarioPreContratracaoConfiguracao",
            prefix: "mdi-cog-outline",
            link: "/dashboard/funcionarioPreContratracaoConfiguracao",
            can: "ROLE_FuncionarioPreContratracaoConfiguracao_List",
          },
        ],
      },
      {
        title: "MovimentacaoDiarias",
        active: false,
        action:
          '<svg width="12px" height="12px" viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>spaceship</title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1720.000000, -592.000000)" fill="#FFFFFF" fill-rule="nonzero"><g transform="translate(1716.000000, 291.000000)"><g transform="translate(4.000000, 301.000000)"><path class="color-background" d="M39.3,0.706666667 C38.9660984,0.370464027 38.5048767,0.192278529 38.0316667,0.216666667 C14.6516667,1.43666667 6.015,22.2633333 5.93166667,22.4733333 C5.68236407,23.0926189 5.82664679,23.8009159 6.29833333,24.2733333 L15.7266667,33.7016667 C16.2013871,34.1756798 16.9140329,34.3188658 17.535,34.065 C17.7433333,33.98 38.4583333,25.2466667 39.7816667,1.97666667 C39.8087196,1.50414529 39.6335979,1.04240574 39.3,0.706666667 Z M25.69,19.0233333 C24.7367525,19.9768687 23.3029475,20.2622391 22.0572426,19.7463614 C20.8115377,19.2304837 19.9992882,18.0149658 19.9992882,16.6666667 C19.9992882,15.3183676 20.8115377,14.1028496 22.0572426,13.5869719 C23.3029475,13.0710943 24.7367525,13.3564646 25.69,14.31 C26.9912731,15.6116662 26.9912731,17.7216672 25.69,19.0233333 L25.69,19.0233333 Z"></path><path class="color-background" d="M1.855,31.4066667 C3.05106558,30.2024182 4.79973884,29.7296005 6.43969145,30.1670277 C8.07964407,30.6044549 9.36054508,31.8853559 9.7979723,33.5253085 C10.2353995,35.1652612 9.76258177,36.9139344 8.55833333,38.11 C6.70666667,39.9616667 0,40 0,40 C0,40 0,33.2566667 1.855,31.4066667 Z"></path><path class="color-background" d="M17.2616667,3.90166667 C12.4943643,3.07192755 7.62174065,4.61673894 4.20333333,8.04166667 C3.31200265,8.94126033 2.53706177,9.94913142 1.89666667,11.0416667 C1.5109569,11.6966059 1.61721591,12.5295394 2.155,13.0666667 L5.47,16.3833333 C8.55036617,11.4946947 12.5559074,7.25476565 17.2616667,3.90166667 L17.2616667,3.90166667 Z" opacity="0.598539807"></path><path class="color-background" d="M36.0983333,22.7383333 C36.9280725,27.5056357 35.3832611,32.3782594 31.9583333,35.7966667 C31.0587397,36.6879974 30.0508686,37.4629382 28.9583333,38.1033333 C28.3033941,38.4890431 27.4704606,38.3827841 26.9333333,37.845 L23.6166667,34.53 C28.5053053,31.4496338 32.7452344,27.4440926 36.0983333,22.7383333 L36.0983333,22.7383333 Z" opacity="0.598539807"></path></g></g></g></g></svg>',
        group: "MovimentacaoDiarias",
        can: "ROLE_MENU_MovimentacaoDiaria",
        prefix: "mdi-map-marker-path",
        items: [
          {
            title: "MovimentacaoDiarias",
            prefix: "mdi-calendar-multiple-check",
            link: "/dashboard/movimentacoesDiarias",
            can: "ROLE_MovimentacaoDiaria_List",
          },
          {
            title: "MovimentacaoDiariaOrigemExternas",
            prefix: "mdi-source-branch",
            link: "/dashboard/movimentacoesDiariasOrigemExterna",
            can: "ROLE_MovimentacaoDiariaOrigemExterna_List",
          },
          {
            title: "MovimentacaoDiariaMotivoCoberturas",
            prefix: "mdi-comment-question-outline",
            link: "/dashboard/movimentacoesDiariasMotivoCobertura",
            can: "ROLE_MovimentacaoDiariaMotivoCobertura_List",
          },
        ],
      },

      // {
      //   title: "GIU_Gestao_Uniformes",
      //   active: false,
      //   action:
      //     '<svg width="12px" height="12px" viewBox="0 0 46 42" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>customer-support</title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1717.000000, -291.000000)" fill="#FFFFFF" fill-rule="nonzero"><g transform="translate(1716.000000, 291.000000)"><g transform="translate(1.000000, 0.000000)"><path class="color-background" d="M45,0 L26,0 C25.447,0 25,0.447 25,1 L25,20 C25,20.379 25.214,20.725 25.553,20.895 C25.694,20.965 25.848,21 26,21 C26.212,21 26.424,20.933 26.6,20.8 L34.333,15 L45,15 C45.553,15 46,14.553 46,14 L46,1 C46,0.447 45.553,0 45,0 Z" opacity="0.59858631"></path><path class="color-background" d="M22.883,32.86 C20.761,32.012 17.324,31 13,31 C8.676,31 5.239,32.012 3.116,32.86 C1.224,33.619 0,35.438 0,37.494 L0,41 C0,41.553 0.447,42 1,42 L25,42 C25.553,42 26,41.553 26,41 L26,37.494 C26,35.438 24.776,33.619 22.883,32.86 Z"></path><path class="color-background" d="M13,28 C17.432,28 21,22.529 21,18 C21,13.589 17.411,10 13,10 C8.589,10 5,13.589 5,18 C5,22.529 8.568,28 13,28 Z"></path></g></g></g></g></svg>',
      //   group: "compras",
      //   can: "ROLE_MENU_Compras",
      //   prefix: "mdi-devices",
      //   items: [
      //     {
      //       title: "SolicitacaoUniformes",
      //       prefix: "mdi-account-tie-hat",
      //       link: "/dashboard/pedidoUniformes",
      //       can: "ROLE_PedidoUniforme_List",
      //     },
      //     {
      //       title: "CompraPedidos",
      //       prefix: "mdi-shopping-search-outline",
      //       link: "/dashboard/comprapedidos",
      //       can: "ROLE_CompraPedido_List",
      //     },
      //     {
      //       title: "CompraOrcamentos",
      //       prefix: "mdi-store-check-outline",
      //       link: "/dashboard/compraorcamentos",
      //       can: "ROLE_CompraOrcamento_List",
      //     },
      //     {
      //       title: "CompraOrdens",
      //       prefix: "mdi-cart-arrow-down",
      //       link: "/dashboard/compraordens",
      //       can: "ROLE_CompraOrdem_List",
      //     },
      //   ],
      // },

      {
        title: "Beneficio-BEN",
        active: false,
        action:
          '<svg width="12px" height="12px" viewBox="0 0 45 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>shop </title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1716.000000, -439.000000)" fill="#FFFFFF" fill-rule="nonzero"><g transform="translate(1716.000000, 291.000000)"><g transform="translate(0.000000, 148.000000)"><path class="color-background" d="M46.7199583,10.7414583 L40.8449583,0.949791667 C40.4909749,0.360605034 39.8540131,0 39.1666667,0 L7.83333333,0 C7.1459869,0 6.50902508,0.360605034 6.15504167,0.949791667 L0.280041667,10.7414583 C0.0969176761,11.0460037 -1.23209662e-05,11.3946378 -1.23209662e-05,11.75 C-0.00758042603,16.0663731 3.48367543,19.5725301 7.80004167,19.5833333 L7.81570833,19.5833333 C9.75003686,19.5882688 11.6168794,18.8726691 13.0522917,17.5760417 C16.0171492,20.2556967 20.5292675,20.2556967 23.494125,17.5760417 C26.4604562,20.2616016 30.9794188,20.2616016 33.94575,17.5760417 C36.2421905,19.6477597 39.5441143,20.1708521 42.3684437,18.9103691 C45.1927731,17.649886 47.0084685,14.8428276 47.0000295,11.75 C47.0000295,11.3946378 46.9030823,11.0460037 46.7199583,10.7414583 Z" opacity="0.598981585"></path><path class="color-background" d="M39.198,22.4912623 C37.3776246,22.4928106 35.5817531,22.0149171 33.951625,21.0951667 L33.92225,21.1107282 C31.1430221,22.6838032 27.9255001,22.9318916 24.9844167,21.7998837 C24.4750389,21.605469 23.9777983,21.3722567 23.4960833,21.1018359 L23.4745417,21.1129513 C20.6961809,22.6871153 17.4786145,22.9344611 14.5386667,21.7998837 C14.029926,21.6054643 13.533337,21.3722507 13.0522917,21.1018359 C11.4250962,22.0190609 9.63246555,22.4947009 7.81570833,22.4912623 C7.16510551,22.4842162 6.51607673,22.4173045 5.875,22.2911849 L5.875,44.7220845 C5.875,45.9498589 6.7517757,46.9451667 7.83333333,46.9451667 L19.5833333,46.9451667 L19.5833333,33.6066734 L27.4166667,33.6066734 L27.4166667,46.9451667 L39.1666667,46.9451667 C40.2482243,46.9451667 41.125,45.9498589 41.125,44.7220845 L41.125,22.2822926 C40.4887822,22.4116582 39.8442868,22.4815492 39.198,22.4912623 Z"></path></g></g></g></g></svg>',
        group: "beneficio",
        can: "ROLE_MENU_Beneficio",
        prefix: "mdi-account-cash-outline",
        items: [
          {
            title: "BeneficioConvenios",
            prefix: "mdi-account-network-outline",
            link: "/dashboard/BeneficioConvenios",
            can: "ROLE_BeneficioConvenio_List",
          },
          {
            title: "BeneficioConvenioOptantes",
            prefix: "mdi-account-child-outline",
            link: "/dashboard/BeneficioConvenioOptantes",
            can: "ROLE_BeneficioConvenioOptante_List",
          },
          {
            title: "BeneficioPeriodoApuracao",
            prefix: "mdi-account-clock-outline",
            link: "/dashboard/BeneficioPeriodoApuracoes",
            can: "ROLE_BeneficioPeriodoApuracao_List",
          },
          {
            title: "BeneficioApuracoes",
            prefix: "mdi-account-cog-outline",
            link: "/dashboard/BeneficioApuracoes",
            can: "ROLE_BeneficioApuracao_List",
          },
          {
            title: "BeneficioAnaliseCliente",
            prefix: "mdi-account-search-outline",
            link: "/dashboard/BeneficioAnalise/cliente",
            can: "ROLE_BeneficioApuracao_Analise",
          },
          {
            title: "BeneficioDireitosDashboard",
            prefix: "mdi-account-check-outline",
            link: "/dashboard/BeneficioDireitos",
            can: "ROLE_BeneficioConvenioOptante_List",
          },
        ],
      },

      {
        title: "Financeiro",
        active: false,
        action:
          '<svg width="12px" height="12px" viewBox="0 0 43 36" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>credit-card</title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-2169.000000, -745.000000)" fill="#FFFFFF" fill-rule="nonzero"><g transform="translate(1716.000000, 291.000000)"><g transform="translate(453.000000, 454.000000)"><path class="color-background" d="M43,10.7482083 L43,3.58333333 C43,1.60354167 41.3964583,0 39.4166667,0 L3.58333333,0 C1.60354167,0 0,1.60354167 0,3.58333333 L0,10.7482083 L43,10.7482083 Z" opacity="0.593633743"></path><path class="color-background" d="M0,16.125 L0,32.25 C0,34.2297917 1.60354167,35.8333333 3.58333333,35.8333333 L39.4166667,35.8333333 C41.3964583,35.8333333 43,34.2297917 43,32.25 L43,16.125 L0,16.125 Z M19.7083333,26.875 L7.16666667,26.875 L7.16666667,23.2916667 L19.7083333,23.2916667 L19.7083333,26.875 Z M35.8333333,26.875 L28.6666667,26.875 L28.6666667,23.2916667 L35.8333333,23.2916667 L35.8333333,26.875 Z"></path></g></g></g></g></svg>',
        group: "financeiro",
        can: "ROLE_MENU_Financeiro",
        prefix: "mdi-cash",
        items: [
          {
            title: "Fornecedores",
            prefix: "mdi-account-cog",
            link: "/dashboard/fornecedores",
            can: "ROLE_Fornecedor_List",
          },
          {
            title: "Centro_custos",
            prefix: "mdi-account-cash",
            link: "/dashboard/centroCustos",
            can: "ROLE_CentroCusto_List",
          },
          {
            title: "CentroCustoNivel",
            prefix: "mdi-format-list-numbered",
            link: "/dashboard/centroCustoNiveis",
            can: "ROLE_CentroCustoNivel_List",
          },
          {
            title: "RateioCentroCustoPadroes",
            prefix: "mdi-chart-pie",
            link: "/dashboard/rateioCentroCustoPadroes",
            can: "ROLE_RateioCentroCustoPadrao_List",
          },
          {
            title: "OrcamentoAnual",
            prefix: "mdi-calendar-month-outline",
            link: "/dashboard/orcamentosAnuais",
            can: "ROLE_OrcamentoAnual_List",
          },
          {
            title: "Conta_financeira",
            prefix: "mdi-notebook-outline",
            link: "/dashboard/contaFinanceiras",
            can: "ROLE_ContaFinanceira_List",
          },
          {
            title: "ContaFinanceiraNivel",
            prefix: "mdi-file-tree-outline",
            link: "/dashboard/contaFinanceiraNiveis",
            can: "ROLE_ContaFinanceiraNivel_List",
          },
          {
            title: "Conta_bancarias",
            prefix: "mdi-credit-card-multiple-outline",
            link: "/dashboard/contaBancarias",
            can: "ROLE_ContaBancaria_List",
          },
          {
            title: "TituloReceber",
            prefix: "mdi-credit-card-plus",
            link: "/dashboard/tituloReceber",
            can: "ROLE_TituloReceber_List",
          },
          {
            title: "CentralCobrancas",
            prefix: "mdi-email-fast-outline",
            link: "/dashboard/financeiro/cobrancas",
            can: "ROLE_TituloReceber_List",
          },
          {
            title: "TituloPagar",
            prefix: "mdi-credit-card-minus",
            link: "/dashboard/tituloPagar",
            can: "ROLE_TituloPagar_List",
          },
          {
            title: "RegistroRecebimentos",
            prefix: "mdi-bank-plus",
            link: "/dashboard/registroRecebimentos",
            can: "ROLE_RegistroRecebimento_List",
          },
          {
            title: "RegistroPagamentos",
            prefix: "mdi-bank-remove",
            link: "/dashboard/registroPagamentos",
            can: "ROLE_RegistroPagamento_List",
          },
          {
            title: "LancamentosFinanceiros",
            prefix: "mdi-clipboard-check-multiple-outline",
            link: "/dashboard/financeiro/lancamentos",
            can: "ROLE_LancamentoFinanceiro_List",
          },
          {
            title: "FinanceiroPeriodo",
            prefix: "mdi-calendar-lock",
            link: "/dashboard/financeiroPeriodos",
            can: "ROLE_FinanceiroPeriodo_List",
          },
          {
            title: "Conta_bancaria_transferencias",
            prefix: "mdi-bank-transfer",
            link: "/dashboard/contaBancariaTransferencias",
            can: "ROLE_ContaBancariaTransferencia_List",
          },
          {
            title: "extrato.contabancaria",
            prefix: "mdi-bank-transfer-in",
            link: "/dashboard/contaBancarias/extrato",
            can: "ROLE_ContaBancaria_List",
          },

          {
            title: "fluxoDiario",
            prefix: "mdi-tablet-dashboard",
            link: "/dashboard/financeiro/fluxoDiario",
            can: "ROLE_Fluxo_Diario",
          },
          {
            title: "dfc.direto",
            prefix: "mdi-credit-card-edit",
            link: "/dashboard/financeiro/dfc/direto",
            can: "ROLE_DFC_Direto",
          },
          {
            title: "analiseCC",
            prefix: "mdi-credit-card-marker",
            link: "/dashboard/financeiro/analiseCC/analise",
            can: "ROLE_AnaliseCC_Realizado",
          },
          {
            title: "DRE",
            prefix: "mdi-file-chart-outline",
            link: "/dashboard/financeiro/analises/dre",
            can: "ROLE_DRE",
          },
        ],
      },

      {
        title: "ContaVinculada",
        active: false,
        action:
          '<svg width="12px" height="12px" viewBox="0 0 43 36" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>credit-card</title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-2169.000000, -745.000000)" fill="#FFFFFF" fill-rule="nonzero"><g transform="translate(1716.000000, 291.000000)"><g transform="translate(453.000000, 454.000000)"><path class="color-background" d="M43,10.7482083 L43,3.58333333 C43,1.60354167 41.3964583,0 39.4166667,0 L3.58333333,0 C1.60354167,0 0,1.60354167 0,3.58333333 L0,10.7482083 L43,10.7482083 Z" opacity="0.593633743"></path><path class="color-background" d="M0,16.125 L0,32.25 C0,34.2297917 1.60354167,35.8333333 3.58333333,35.8333333 L39.4166667,35.8333333 C41.3964583,35.8333333 43,34.2297917 43,32.25 L43,16.125 L0,16.125 Z M19.7083333,26.875 L7.16666667,26.875 L7.16666667,23.2916667 L19.7083333,23.2916667 L19.7083333,26.875 Z M35.8333333,26.875 L28.6666667,26.875 L28.6666667,23.2916667 L35.8333333,23.2916667 L35.8333333,26.875 Z"></path></g></g></g></g></svg>',
        group: "ContaVinculada",
        can: "ROLE_MENU_ContaVinculada",
        prefix: "mdi-cash",
        items: [
          {
            title: "ContaVinculadaMovimentacoes",
            prefix: "mdi-account-cog",
            link: "/dashboard/contaVinculadaMovimentacoes",
            can: "ROLE_ContaVinculadaMovimentacao_List",
          },
        ],
      },

      {
        title: "GESTAOORCAMENTODESPESA",
        active: false,
        action:
          '<svg class="text-dark" width="12px" height="12px" viewBox="0 0 42 44" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>basket</title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1869.000000, -741.000000)" fill="#FFFFFF" fill-rule="nonzero"><g transform="translate(1716.000000, 291.000000)"><g id="basket" transform="translate(153.000000, 450.000000)"><path class="color-background" d="M34.080375,13.125 L27.3748125,1.9490625 C27.1377583,1.53795093 26.6972449,1.28682264 26.222716,1.29218729 C25.748187,1.29772591 25.3135593,1.55890827 25.0860125,1.97535742 C24.8584658,2.39180657 24.8734447,2.89865282 25.1251875,3.3009375 L31.019625,13.125 L10.980375,13.125 L16.8748125,3.3009375 C17.1265553,2.89865282 17.1415342,2.39180657 16.9139875,1.97535742 C16.6864407,1.55890827 16.251813,1.29772591 15.777284,1.29218729 C15.3027551,1.28682264 14.8622417,1.53795093 14.6251875,1.9490625 L7.919625,13.125 L0,13.125 L0,18.375 L42,18.375 L42,13.125 L34.080375,13.125 Z" opacity="0.595377604"></path><path class="color-background" d="M3.9375,21 L3.9375,38.0625 C3.9375,40.9619949 6.28800506,43.3125 9.1875,43.3125 L32.8125,43.3125 C35.7119949,43.3125 38.0625,40.9619949 38.0625,38.0625 L38.0625,21 L3.9375,21 Z M14.4375,36.75 L11.8125,36.75 L11.8125,26.25 L14.4375,26.25 L14.4375,36.75 Z M22.3125,36.75 L19.6875,36.75 L19.6875,26.25 L22.3125,26.25 L22.3125,36.75 Z M30.1875,36.75 L27.5625,36.75 L27.5625,26.25 L30.1875,26.25 L30.1875,36.75 Z"></path></g></g></g></g></svg>',
        group: "orcamentoDespesa",
        can: "ROLE_Menu_GestaoOrcamentoDespesa",
        prefix: "mdi-cash",
        items: [
          {
            title: "PedidoOrcamentoDespesa",
            prefix: "mdi-account-cash",
            link: "/dashboard/orcamentoDespesa",
            can: "ROLE_PedidoOrcamentoDespesa_List",
          },
          {
            title: "DashboardOrcamentoDespesa",
            prefix: "mdi-chart-box-outline",
            link: "/dashboard/orcamentoDespesa/painel",
            can: "ROLE_PedidoOrcamentoDespesa_List",
          },
        ],
      },

      {
        title: "Faturamento",
        active: false,
        action:
          '<svg width="12px" height="12px" viewBox="0 0 43 36" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>credit-card</title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-2169.000000, -745.000000)" fill="#FFFFFF" fill-rule="nonzero"><g transform="translate(1716.000000, 291.000000)"><g transform="translate(453.000000, 454.000000)"><path class="color-background" d="M43,10.7482083 L43,3.58333333 C43,1.60354167 41.3964583,0 39.4166667,0 L3.58333333,0 C1.60354167,0 0,1.60354167 0,3.58333333 L0,10.7482083 L43,10.7482083 Z" opacity="0.593633743"></path><path class="color-background" d="M0,16.125 L0,32.25 C0,34.2297917 1.60354167,35.8333333 3.58333333,35.8333333 L39.4166667,35.8333333 C41.3964583,35.8333333 43,34.2297917 43,32.25 L43,16.125 L0,16.125 Z M19.7083333,26.875 L7.16666667,26.875 L7.16666667,23.2916667 L19.7083333,23.2916667 L19.7083333,26.875 Z M35.8333333,26.875 L28.6666667,26.875 L28.6666667,23.2916667 L35.8333333,23.2916667 L35.8333333,26.875 Z"></path></g></g></g></g></svg>',
        group: "faturamento",
        can: "ROLE_MENU_Faturamento",
        prefix: "mdi-currency-usd",
        items: [
          {
            title: "CalculoFaturamento" /*titulo*/,
            prefix: "mdi-cash-multiple" /*ícone*/,
            link: "/dashboard/calculoFaturamentos" /*Href*/,
            can: "ROLE_FaturamentoCalculo_List" /*Can*/,
          },
          {
            title: "DocumentoFiscal" /*titulo*/,
            prefix: "mdi-text-box-multiple-outline" /*ícone*/,
            link: "/dashboard/documentoFiscais" /*Href*/,
            can: "ROLE_FaturamentoDocumentoFiscal_List" /*Can*/,
          },
          {
            title: "FaturamentoPeriodo" /*titulo*/,
            prefix: "mdi-calendar-lock" /*ícone*/,
            link: "/dashboard/faturamentoPeriodos" /*Href*/,
            can: "ROLE_FaturamentoPeriodo_List" /*Can*/,
          },
          {
            title: "faturamentovariaveisservicos" /*titulo*/,
            prefix: "mdi-cash-register" /*ícone*/,
            link: "/dashboard/faturamentovariaveisservicos" /*Href*/,
            can: "ROLE_FaturamentoVariaveisServico_List" /*Can*/,
          },
          {
            title: "PracaFiscal" /*titulo*/,
            prefix: "mdi-dots-square" /*ícone*/,
            link: "/dashboard/pracaFiscais" /*Href*/,
            can: "ROLE_FaturamentoPracaFiscal_List" /*Can*/,
          },

          {
            title: "MetodoCobrancas" /*titulo*/,
            prefix: "mdi-cash-register" /*ícone*/,
            link: "/dashboard/metodocobrancas" /*Href*/,
            can: "ROLE_MetodoCobranca_List" /*Can*/,
          },
          {
            title: "ProdutoTransporte" /*titulo*/,
            prefix: "mdi-dots-square" /*ícone*/,
            link: "/dashboard/faturamento/produtoTransporte" /*Href*/,
            can: "ROLE_FaturamentoProdutoTransporte_List" /*Can*/,
          },
          {
            title: "DashboardFaturamento",
            prefix: "mdi-account-tie-hat",
            link: "/dashboard/faturamento/dashboard",
            can: "ROLE_FaturamentoDocumentoFiscal_List",
          },
          {
            title: "CurvaABCFaturamento",
            prefix: "mdi-chart-bell-curve-cumulative",
            link: "/dashboard/faturamento/curva-abc",
            can: "ROLE_FaturamentoDocumentoFiscal_List",
          },
        ],
      },

      {
        title: "Compras",
        active: false,
        action:
          '<svg class="text-dark" width="12px" height="12px" viewBox="0 0 42 44" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>basket</title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1869.000000, -741.000000)" fill="#FFFFFF" fill-rule="nonzero"><g transform="translate(1716.000000, 291.000000)"><g id="basket" transform="translate(153.000000, 450.000000)"><path class="color-background" d="M34.080375,13.125 L27.3748125,1.9490625 C27.1377583,1.53795093 26.6972449,1.28682264 26.222716,1.29218729 C25.748187,1.29772591 25.3135593,1.55890827 25.0860125,1.97535742 C24.8584658,2.39180657 24.8734447,2.89865282 25.1251875,3.3009375 L31.019625,13.125 L10.980375,13.125 L16.8748125,3.3009375 C17.1265553,2.89865282 17.1415342,2.39180657 16.9139875,1.97535742 C16.6864407,1.55890827 16.251813,1.29772591 15.777284,1.29218729 C15.3027551,1.28682264 14.8622417,1.53795093 14.6251875,1.9490625 L7.919625,13.125 L0,13.125 L0,18.375 L42,18.375 L42,13.125 L34.080375,13.125 Z" opacity="0.595377604"></path><path class="color-background" d="M3.9375,21 L3.9375,38.0625 C3.9375,40.9619949 6.28800506,43.3125 9.1875,43.3125 L32.8125,43.3125 C35.7119949,43.3125 38.0625,40.9619949 38.0625,38.0625 L38.0625,21 L3.9375,21 Z M14.4375,36.75 L11.8125,36.75 L11.8125,26.25 L14.4375,26.25 L14.4375,36.75 Z M22.3125,36.75 L19.6875,36.75 L19.6875,26.25 L22.3125,26.25 L22.3125,36.75 Z M30.1875,36.75 L27.5625,36.75 L27.5625,26.25 L30.1875,26.25 L30.1875,36.75 Z"></path></g></g></g></g></svg>',
        group: "compras",
        can: "ROLE_MENU_Compras",
        prefix: "mdi-shopping-outline",
        items: [
          {
            title: "CompraPedidos",
            prefix: "mdi-shopping-search-outline",
            link: "/dashboard/comprapedidos",
            can: "ROLE_CompraPedido_List",
          },
          {
            title: "CompraOrcamentos",
            prefix: "mdi-store-check-outline",
            link: "/dashboard/compraorcamentos",
            can: "ROLE_CompraOrcamento_List",
          },
          {
            title: "CompraOrdens",
            prefix: "mdi-cart-arrow-down",
            link: "/dashboard/compraordens",
            can: "ROLE_CompraOrdem_List",
          },
          {
            title: "ComprasEmissoesCnpj",
            prefix: "mdi-file-search-outline",
            link: "/dashboard/compras/emissoes-cnpj",
            can: "ROLE_CompraOrdem_List",
          },
          {
            title: "PlanejamentoCompraSubstituicaoUniformes",
            prefix: "mdi-tshirt-crew-outline",
            link: "/dashboard/uniformes/planejamentoCompra",
            can: "ROLE_CompraPedido_Insert",
          },
          {
            title: "ComprasMinhaSolicitacao",
            prefix: "mdi-cart-plus",
            link: "/dashboard/compras/minha-solicitacao",
            can: "ROLE_CompraPeriodoSolicitacaoPropria_List",
          },
          {
            title: "ComprasPeriodos",
            prefix: "mdi-calendar-month-outline",
            link: "/dashboard/compras/periodos",
            can: "ROLE_CompraPeriodo_List",
          },
          {
            title: "ComprasEntregas",
            prefix: "mdi-truck-delivery-outline",
            link: "/dashboard/compras/entregas",
            can: "ROLE_CompraEntrega_List",
          },
          {
            title: "ComprasRecebimentos",
            prefix: "mdi-package-variant-closed-check",
            link: "/dashboard/compras/recebimentos",
            can: "ROLE_CompraEntregaRecebimento_List",
          },
        ],
      },

      {
        title: "GSC",
        active: false,
        action:
          '<svg class="text-dark" width="12px" height="12px" viewBox="0 0 42 44" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>basket</title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1869.000000, -741.000000)" fill="#FFFFFF" fill-rule="nonzero"><g transform="translate(1716.000000, 291.000000)"><g id="basket" transform="translate(153.000000, 450.000000)"><path class="color-background" d="M34.080375,13.125 L27.3748125,1.9490625 C27.1377583,1.53795093 26.6972449,1.28682264 26.222716,1.29218729 C25.748187,1.29772591 25.3135593,1.55890827 25.0860125,1.97535742 C24.8584658,2.39180657 24.8734447,2.89865282 25.1251875,3.3009375 L31.019625,13.125 L10.980375,13.125 L16.8748125,3.3009375 C17.1265553,2.89865282 17.1415342,2.39180657 16.9139875,1.97535742 C16.6864407,1.55890827 16.251813,1.29772591 15.777284,1.29218729 C15.3027551,1.28682264 14.8622417,1.53795093 14.6251875,1.9490625 L7.919625,13.125 L0,13.125 L0,18.375 L42,18.375 L42,13.125 L34.080375,13.125 Z" opacity="0.595377604"></path><path class="color-background" d="M3.9375,21 L3.9375,38.0625 C3.9375,40.9619949 6.28800506,43.3125 9.1875,43.3125 L32.8125,43.3125 C35.7119949,43.3125 38.0625,40.9619949 38.0625,38.0625 L38.0625,21 L3.9375,21 Z M14.4375,36.75 L11.8125,36.75 L11.8125,26.25 L14.4375,26.25 L14.4375,36.75 Z M22.3125,36.75 L19.6875,36.75 L19.6875,26.25 L22.3125,26.25 L22.3125,36.75 Z M30.1875,36.75 L27.5625,36.75 L27.5625,26.25 L30.1875,26.25 L30.1875,36.75 Z"></path></g></g></g></g></svg>',
        group: "GSC",
        can: "ROLE_MENU_GSC",
        prefix: "mdi-shopping-outline",
        items: [
          {
            title: "SolicitacaoCompras",
            prefix: "mdi-clipboard-list-outline",
            link: "/dashboard/solicitacaoCompras",
            can: "ROLE_SolicitacaoCompra_List",
          },
        ],
      },

      {
        title: "Recursos",
        active: false,
        action:
          '<svg width="12px" height="12px" viewBox="0 0 42 42" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>office</title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1869.000000, -293.000000)" fill="#FFFFFF" fill-rule="nonzero"><g transform="translate(1716.000000, 291.000000)"><g id="office" transform="translate(153.000000, 2.000000)"><path class="color-background" d="M12.25,17.5 L8.75,17.5 L8.75,1.75 C8.75,0.78225 9.53225,0 10.5,0 L31.5,0 C32.46775,0 33.25,0.78225 33.25,1.75 L33.25,12.25 L29.75,12.25 L29.75,3.5 L12.25,3.5 L12.25,17.5 Z" opacity="0.6"></path><path class="color-background" d="M40.25,14 L24.5,14 C23.53225,14 22.75,14.78225 22.75,15.75 L22.75,38.5 L19.25,38.5 L19.25,22.75 C19.25,21.78225 18.46775,21 17.5,21 L1.75,21 C0.78225,21 0,21.78225 0,22.75 L0,40.25 C0,41.21775 0.78225,42 1.75,42 L40.25,42 C41.21775,42 42,41.21775 42,40.25 L42,15.75 C42,14.78225 41.21775,14 40.25,14 Z M12.25,36.75 L7,36.75 L7,33.25 L12.25,33.25 L12.25,36.75 Z M12.25,29.75 L7,29.75 L7,26.25 L12.25,26.25 L12.25,29.75 Z M35,36.75 L29.75,36.75 L29.75,33.25 L35,33.25 L35,36.75 Z M35,29.75 L29.75,29.75 L29.75,26.25 L35,26.25 L35,29.75 Z M35,22.75 L29.75,22.75 L29.75,19.25 L35,19.25 L35,22.75 Z"></path></g></g></g></g></svg>',
        group: "recursos",
        can: "ROLE_MENU_Recursos",
        prefix: "mdi-bookshelf",
        items: [
          {
            title: "CentroEstoque",
            prefix: "mdi-basket",
            link: "/dashboard/centroEstoques",
            can: "ROLE_CentroEstoque_List",
          },
          {
            title: "Produtos",
            prefix: "mdi-barcode-scan",
            link: "/dashboard/produtos",
            can: "ROLE_Produto_List",
          },
          {
            title: "Inventario",
            prefix: "mdi-clipboard-list-outline",
            link: "/dashboard/inventario",
            can: "ROLE_Produto_List",
          },
          {
            title: "SolicitacaoMateriais",
            prefix: "mdi-order-bool-ascending-variant",
            link: "/dashboard/pedidoMateriais",
            can: "ROLE_PedidoMaterial_List",
          },
          {
            title: "SolicitacaoUniformes",
            prefix: "mdi-account-tie-hat",
            link: "/dashboard/pedidoUniformes",
            can: "ROLE_PedidoUniforme_List",
          },
          {
            title: "DashboardUniformes",
            prefix: "mdi-account-tie-hat",
            link: "/dashboard/uniformes/dashboard",
            can: "ROLE_PedidoUniforme_List",
          },

          {
            title: "PedidoConsumiveisProprios",
            prefix: "mdi-basket-outline",
            link: "/dashboard/meusPedidosConsumiveis",
            can: "ROLE_PedidoConsumivelProprio_List",
          },
          {
            title: "SolicitacaoConsumiveis",
            prefix: "mdi-basket-fill",
            link: "/dashboard/pedidoConsumiveis",
            can: "ROLE_PedidoConsumivel_List",
          },
          {
            title: "ImobilizadoClassificacoes",
            prefix: "mdi-file-cabinet",
            link: "/dashboard/imobilizadoclassificacoes",
            can: "ROLE_Imobilizado_List",
          },
          {
            title: "ImobilizadoMovimentacaoConsulta",
            prefix: "mdi-file-cabinet",
            link: "/dashboard/imobilizadoMovimentacaoConsulta",
            can: "ROLE_ImobilizadoMovimentacaoItem_Export",
          },

          {
            title: "Imobilizados",
            prefix: "mdi-file-cabinet",
            link: "/dashboard/imobilizados",
            can: "ROLE_Imobilizado_List",
          },
          {
            title: "Imobilizado_movimentacoes",
            prefix: "mdi-file-sync",
            link: "/dashboard/imobilizadoMovimentacoes",
            can: "ROLE_ImobilizadoMovimentacao_List",
          },
          {
            title: "PainelRetornoImobilizados",
            prefix: "mdi-calendar-clock-outline",
            link: "/dashboard/imobilizadoMovimentacoes/retornos",
            can: "ROLE_ImobilizadoMovimentacao_List",
          },
          {
            title: "Vinculos_produtos_centros_estoque",
            prefix: "mdi-link-variant",
            link: "/dashboard/produtosCentroEstoque",
            can: "ROLE_ProdutoCentroEstoque_List",
          },
          {
            title: "PedidoConsumivelCentroEstoque",
            prefix: "mdi-basket",
            link: "/dashboard/pedidosConsumivelCentroEstoque",
            can: "ROLE_PedidoConsumivelCentroEstoque_List",
          },
        ],
      },

      // {
      //   title: "GOP_Gestao_Operacional",
      //   active: false,
      //   action:
      //     '<svg width="12px" height="12px" viewBox="0 0 45 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>shop </title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1716.000000, -439.000000)" fill="#FFFFFF" fill-rule="nonzero"><g transform="translate(1716.000000, 291.000000)"><g transform="translate(0.000000, 148.000000)"><path class="color-background" d="M46.7199583,10.7414583 L40.8449583,0.949791667 C40.4909749,0.360605034 39.8540131,0 39.1666667,0 L7.83333333,0 C7.1459869,0 6.50902508,0.360605034 6.15504167,0.949791667 L0.280041667,10.7414583 C0.0969176761,11.0460037 -1.23209662e-05,11.3946378 -1.23209662e-05,11.75 C-0.00758042603,16.0663731 3.48367543,19.5725301 7.80004167,19.5833333 L7.81570833,19.5833333 C9.75003686,19.5882688 11.6168794,18.8726691 13.0522917,17.5760417 C16.0171492,20.2556967 20.5292675,20.2556967 23.494125,17.5760417 C26.4604562,20.2616016 30.9794188,20.2616016 33.94575,17.5760417 C36.2421905,19.6477597 39.5441143,20.1708521 42.3684437,18.9103691 C45.1927731,17.649886 47.0084685,14.8428276 47.0000295,11.75 C47.0000295,11.3946378 46.9030823,11.0460037 46.7199583,10.7414583 Z" opacity="0.598981585"></path><path class="color-background" d="M39.198,22.4912623 C37.3776246,22.4928106 35.5817531,22.0149171 33.951625,21.0951667 L33.92225,21.1107282 C31.1430221,22.6838032 27.9255001,22.9318916 24.9844167,21.7998837 C24.4750389,21.605469 23.9777983,21.3722567 23.4960833,21.1018359 L23.4745417,21.1129513 C20.6961809,22.6871153 17.4786145,22.9344611 14.5386667,21.7998837 C14.029926,21.6054643 13.533337,21.3722507 13.0522917,21.1018359 C11.4250962,22.0190609 9.63246555,22.4947009 7.81570833,22.4912623 C7.16510551,22.4842162 6.51607673,22.4173045 5.875,22.2911849 L5.875,44.7220845 C5.875,45.9498589 6.7517757,46.9451667 7.83333333,46.9451667 L19.5833333,46.9451667 L19.5833333,33.6066734 L27.4166667,33.6066734 L27.4166667,46.9451667 L39.1666667,46.9451667 C40.2482243,46.9451667 41.125,45.9498589 41.125,44.7220845 L41.125,22.2822926 C40.4887822,22.4116582 39.8442868,22.4815492 39.198,22.4912623 Z"></path></g></g></g></g></svg>',
      //   group: "clientes",
      //   can: "ROLE_MENU_Comercial",
      //   prefix: "mdi-shopping-outline",
      //   items: [
      //     {
      //       title: "PostoTrabalhos" /*titulo*/,
      //       prefix: "mdi-book-marker-outline" /*ícone*/,
      //       link: "/dashboard/postoTrabalhos" /*Href*/,
      //       can: "ROLE_PostoTrabalho_List" /*Can*/,
      //     },
      //   ],
      // },

      /*{
        title: "LOD_Livro_Ocorrencia_Digital",
        active: false,
        action:
          '<svg class="text-dark" width="12px" height="12px" viewBox="0 0 42 44" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>basket</title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1869.000000, -741.000000)" fill="#FFFFFF" fill-rule="nonzero"><g transform="translate(1716.000000, 291.000000)"><g id="basket" transform="translate(153.000000, 450.000000)"><path class="color-background" d="M34.080375,13.125 L27.3748125,1.9490625 C27.1377583,1.53795093 26.6972449,1.28682264 26.222716,1.29218729 C25.748187,1.29772591 25.3135593,1.55890827 25.0860125,1.97535742 C24.8584658,2.39180657 24.8734447,2.89865282 25.1251875,3.3009375 L31.019625,13.125 L10.980375,13.125 L16.8748125,3.3009375 C17.1265553,2.89865282 17.1415342,2.39180657 16.9139875,1.97535742 C16.6864407,1.55890827 16.251813,1.29772591 15.777284,1.29218729 C15.3027551,1.28682264 14.8622417,1.53795093 14.6251875,1.9490625 L7.919625,13.125 L0,13.125 L0,18.375 L42,18.375 L42,13.125 L34.080375,13.125 Z" opacity="0.595377604"></path><path class="color-background" d="M3.9375,21 L3.9375,38.0625 C3.9375,40.9619949 6.28800506,43.3125 9.1875,43.3125 L32.8125,43.3125 C35.7119949,43.3125 38.0625,40.9619949 38.0625,38.0625 L38.0625,21 L3.9375,21 Z M14.4375,36.75 L11.8125,36.75 L11.8125,26.25 L14.4375,26.25 L14.4375,36.75 Z M22.3125,36.75 L19.6875,36.75 L19.6875,26.25 L22.3125,26.25 L22.3125,36.75 Z M30.1875,36.75 L27.5625,36.75 L27.5625,26.25 L30.1875,26.25 L30.1875,36.75 Z"></path></g></g></g></g></svg>',
        group: "clientes",
        can: "ROLE_MENU_Comercial",
        prefix: "mdi-shopping-outline",
        items: [
        {
            title: "PostoTrabalhos",
            prefix: "mdi-book-marker-outline",
            link: "/dashboard/postoTrabalhos",
            can: "ROLE_PostoTrabalho_List",
          },
        ],
      },*/

      {
        title: "Operacoes",
        active: false,
        action:
          '<svg width="12px" height="12px" viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>spaceship</title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1720.000000, -592.000000)" fill="#FFFFFF" fill-rule="nonzero"><g transform="translate(1716.000000, 291.000000)"><g transform="translate(4.000000, 301.000000)"><path class="color-background" d="M39.3,0.706666667 C38.9660984,0.370464027 38.5048767,0.192278529 38.0316667,0.216666667 C14.6516667,1.43666667 6.015,22.2633333 5.93166667,22.4733333 C5.68236407,23.0926189 5.82664679,23.8009159 6.29833333,24.2733333 L15.7266667,33.7016667 C16.2013871,34.1756798 16.9140329,34.3188658 17.535,34.065 C17.7433333,33.98 38.4583333,25.2466667 39.7816667,1.97666667 C39.8087196,1.50414529 39.6335979,1.04240574 39.3,0.706666667 Z M25.69,19.0233333 C24.7367525,19.9768687 23.3029475,20.2622391 22.0572426,19.7463614 C20.8115377,19.2304837 19.9992882,18.0149658 19.9992882,16.6666667 C19.9992882,15.3183676 20.8115377,14.1028496 22.0572426,13.5869719 C23.3029475,13.0710943 24.7367525,13.3564646 25.69,14.31 C26.9912731,15.6116662 26.9912731,17.7216672 25.69,19.0233333 L25.69,19.0233333 Z"></path><path class="color-background" d="M1.855,31.4066667 C3.05106558,30.2024182 4.79973884,29.7296005 6.43969145,30.1670277 C8.07964407,30.6044549 9.36054508,31.8853559 9.7979723,33.5253085 C10.2353995,35.1652612 9.76258177,36.9139344 8.55833333,38.11 C6.70666667,39.9616667 0,40 0,40 C0,40 0,33.2566667 1.855,31.4066667 Z"></path><path class="color-background" d="M17.2616667,3.90166667 C12.4943643,3.07192755 7.62174065,4.61673894 4.20333333,8.04166667 C3.31200265,8.94126033 2.53706177,9.94913142 1.89666667,11.0416667 C1.5109569,11.6966059 1.61721591,12.5295394 2.155,13.0666667 L5.47,16.3833333 C8.55036617,11.4946947 12.5559074,7.25476565 17.2616667,3.90166667 L17.2616667,3.90166667 Z" opacity="0.598539807"></path><path class="color-background" d="M36.0983333,22.7383333 C36.9280725,27.5056357 35.3832611,32.3782594 31.9583333,35.7966667 C31.0587397,36.6879974 30.0508686,37.4629382 28.9583333,38.1033333 C28.3033941,38.4890431 27.4704606,38.3827841 26.9333333,37.845 L23.6166667,34.53 C28.5053053,31.4496338 32.7452344,27.4440926 36.0983333,22.7383333 L36.0983333,22.7383333 Z" opacity="0.598539807"></path></g></g></g></g></svg>',
        group: "operacoes",
        can: "ROLE_MENU_Operacoes",
        prefix: "mdi-map-marker-path",
        items: [
          // {
          //   title: "Veiculos",
          //   prefix: "mdi-car-multiple",
          //   link: "/dashboard/veiculos",
          //   can: "ROLE_Veiculo_List",
          // },
          // {
          //   title: "Modelos_de_veiculos",
          //   prefix: "mdi-car-info",
          //   link: "/dashboard/veiculoModelos",
          //   can: "ROLE_VeiculoModelo_List",
          // },
          {
            title: "Pedidos",
            prefix: "mdi-order-bool-ascending-variant",
            link: "/dashboard/pedidos",
            can: "ROLE_Pedido_List",
          },
          {
            title: "Roteiros",
            prefix: "mdi-transit-connection-variant",
            link: "/dashboard/roteiros",
            can: "ROLE_Roteiro_List",
          },
          {
            title: "RoteiroModelos",
            prefix: "mdi-transit-connection-variant",
            link: "/dashboard/roteiroModelos",
            can: "ROLE_RoteiroModelo_List",
          },
          {
            title: "AcompanhamentoTrajetos",
            prefix: "mdi-transit-connection-variant",
            link: "/dashboard/acompanhamento/trajetos",
            can: "ROLE_Roteiro_List",
          },
          {
            title: "GuiaTransporte",
            prefix: "mdi-transit-connection-variant",
            link: "/dashboard/guiaTransportes",
            can: "ROLE_GuiaTransporte_List",
          },
          {
            title: "Equipamentos",
            prefix: "ni-ruler-pencil-box-multiple-outline",
            link: "/dashboard/equipamentos",
            can: "ROLE_Equipamento_List",
          },
          {
            title: "CentroDepositos",
            prefix: "mdi-warehouse",
            link: "/dashboard/centroDepositos",
            can: "ROLE_CentroDeposito_List",
          },
          {
            title: "EquipamentoAnaliseMovimentacao",
            prefix: "mdi-transit-connection-variant",
            link: "/dashboard/analiseMovimentacaoEquipamentos",
            can: "ROLE_Equipamento_Movement",
          },
          {
            title: "AnaliseMovimentacaoCentroDeposito",
            prefix: "mdi-warehouse",
            link: "/dashboard/analiseMovimentacaoCentroDeposito",
            can: "ROLE_Equipamento_Movement_Cliente",
          },
          {
            title: "EquipamentoAnaliseCredito",
            prefix: "mdi-transit-connection-variant",
            link: "/dashboard/analiseSaldoLogicoEquipamentos",
            can: "ROLE_Equipamento_Credit",
          },
          {
            title: "EquipamentosDashboard01",
            prefix: "mdi-transit-connection-variant",
            link: "/dashboard/equipamentos/dashboard01",
            can: "ROLE_Equipamento_Dashboard",
          },
          {
            title: "EquipamentoAnaliseMovimentacao",
            prefix: "mdi-transit-connection-variant",
            link: "/dashboard/analiseMovimentacaoEquipamentos/cliente",
            can: "ROLE_Equipamento_Movement_Cliente",
          },
          {
            title: "EquipamentoAnaliseCredito",
            prefix: "mdi-transit-connection-variant",
            link: "/dashboard/analiseSaldoLogicoEquipamentos/cliente",
            can: "ROLE_Equipamento_Credit_Cliente",
          },
          {
            title: "CodigoIdentificacaoReciprocas",
            prefix: "mdi-transit-connection-variant",
            link: "/dashboard/codigoIdentificacaoReciprocas",
            can: "ROLE_CodigoIdentificacaoReciproca_List",
          },
          {
            title: "EquipamentoEncerramentoApuracaoSaldoData",
            prefix: "mdi-transit-connection-variant",
            link: "/dashboard/equipamentoEncerramentoApuracaoSaldoDatas",
            can: "ROLE_EquipamentoEncerramentoApuracaoSaldoData_List",
          },
          {
            title: "LogisticaTipoEvento",
            prefix: "mdi-transit-connection-variant",
            link: "/dashboard/logisticaTipoEvento",
            can: "ROLE_LogisticaTipoEvento_List",
          },
          {
            title: "LogisticaTipoOcorrencia",
            prefix: "mdi-transit-connection-variant",
            link: "/dashboard/logisticaTipoOcorrencia",
            can: "ROLE_LogisticaTipoOcorrencia_List",
          },
          {
            title: "AssistenciaTecnicaTipo",
            prefix: "mdi-transit-connection-variant",
            link: "/dashboard/assistenciaTecnicaTipo",
            can: "ROLE_AssistenciaTecnicaTipo_List",
          },
        ],
      },
      {
        title: "SPT",
        active: false,
        action:
          '<svg width="12px" height="12px" viewBox="0 0 45 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>shop </title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1716.000000, -439.000000)" fill="#FFFFFF" fill-rule="nonzero"><g transform="translate(1716.000000, 291.000000)"><g transform="translate(0.000000, 148.000000)"><path class="color-background" d="M46.7199583,10.7414583 L40.8449583,0.949791667 C40.4909749,0.360605034 39.8540131,0 39.1666667,0 L7.83333333,0 C7.1459869,0 6.50902508,0.360605034 6.15504167,0.949791667 L0.280041667,10.7414583 C0.0969176761,11.0460037 -1.23209662e-05,11.3946378 -1.23209662e-05,11.75 C-0.00758042603,16.0663731 3.48367543,19.5725301 7.80004167,19.5833333 L7.81570833,19.5833333 C9.75003686,19.5882688 11.6168794,18.8726691 13.0522917,17.5760417 C16.0171492,20.2556967 20.5292675,20.2556967 23.494125,17.5760417 C26.4604562,20.2616016 30.9794188,20.2616016 33.94575,17.5760417 C36.2421905,19.6477597 39.5441143,20.1708521 42.3684437,18.9103691 C45.1927731,17.649886 47.0084685,14.8428276 47.0000295,11.75 C47.0000295,11.3946378 46.9030823,11.0460037 46.7199583,10.7414583 Z" opacity="0.598981585"></path><path class="color-background" d="M39.198,22.4912623 C37.3776246,22.4928106 35.5817531,22.0149171 33.951625,21.0951667 L33.92225,21.1107282 C31.1430221,22.6838032 27.9255001,22.9318916 24.9844167,21.7998837 C24.4750389,21.605469 23.9777983,21.3722567 23.4960833,21.1018359 L23.4745417,21.1129513 C20.6961809,22.6871153 17.4786145,22.9344611 14.5386667,21.7998837 C14.029926,21.6054643 13.533337,21.3722507 13.0522917,21.1018359 C11.4250962,22.0190609 9.63246555,22.4947009 7.81570833,22.4912623 C7.16510551,22.4842162 6.51607673,22.4173045 5.875,22.2911849 L5.875,44.7220845 C5.875,45.9498589 6.7517757,46.9451667 7.83333333,46.9451667 L19.5833333,46.9451667 L19.5833333,33.6066734 L27.4166667,33.6066734 L27.4166667,46.9451667 L39.1666667,46.9451667 C40.2482243,46.9451667 41.125,45.9498589 41.125,44.7220845 L41.125,22.2822926 C40.4887822,22.4116582 39.8442868,22.4815492 39.198,22.4912623 Z"></path></g></g></g></g></svg>',
        group: "clientes",
        can: "ROLE_MENU_PostoTrabalhoSupervisao",
        prefix: "mdi-handshake-outline",
        items: [
          {
            title: "Questionarios",
            prefix: "ni-ruler-pencil-box-multiple-outline",
            link: "/dashboard/questionarios",
            can: "ROLE_Questionario_List",
          },
          {
            title: "PostoTrabalhoSupervisoes",
            prefix: "mdi-clipboard-text-search-outline",
            link: "/dashboard/postoTrabalhoSupervisoes",
            can: "ROLE_PostoTrabalhoSupervisao_List",
          },
        ],
      },

      {
        title: "RPT",
        active: false,
        action:
          '<svg width="12px" height="12px" viewBox="0 0 45 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>shop </title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1716.000000, -439.000000)" fill="#FFFFFF" fill-rule="nonzero"><g transform="translate(1716.000000, 291.000000)"><g transform="translate(0.000000, 148.000000)"><path class="color-background" d="M46.7199583,10.7414583 L40.8449583,0.949791667 C40.4909749,0.360605034 39.8540131,0 39.1666667,0 L7.83333333,0 C7.1459869,0 6.50902508,0.360605034 6.15504167,0.949791667 L0.280041667,10.7414583 C0.0969176761,11.0460037 -1.23209662e-05,11.3946378 -1.23209662e-05,11.75 C-0.00758042603,16.0663731 3.48367543,19.5725301 7.80004167,19.5833333 L7.81570833,19.5833333 C9.75003686,19.5882688 11.6168794,18.8726691 13.0522917,17.5760417 C16.0171492,20.2556967 20.5292675,20.2556967 23.494125,17.5760417 C26.4604562,20.2616016 30.9794188,20.2616016 33.94575,17.5760417 C36.2421905,19.6477597 39.5441143,20.1708521 42.3684437,18.9103691 C45.1927731,17.649886 47.0084685,14.8428276 47.0000295,11.75 C47.0000295,11.3946378 46.9030823,11.0460037 46.7199583,10.7414583 Z" opacity="0.598981585"></path><path class="color-background" d="M39.198,22.4912623 C37.3776246,22.4928106 35.5817531,22.0149171 33.951625,21.0951667 L33.92225,21.1107282 C31.1430221,22.6838032 27.9255001,22.9318916 24.9844167,21.7998837 C24.4750389,21.605469 23.9777983,21.3722567 23.4960833,21.1018359 L23.4745417,21.1129513 C20.6961809,22.6871153 17.4786145,22.9344611 14.5386667,21.7998837 C14.029926,21.6054643 13.533337,21.3722507 13.0522917,21.1018359 C11.4250962,22.0190609 9.63246555,22.4947009 7.81570833,22.4912623 C7.16510551,22.4842162 6.51607673,22.4173045 5.875,22.2911849 L5.875,44.7220845 C5.875,45.9498589 6.7517757,46.9451667 7.83333333,46.9451667 L19.5833333,46.9451667 L19.5833333,33.6066734 L27.4166667,33.6066734 L27.4166667,46.9451667 L39.1666667,46.9451667 C40.2482243,46.9451667 41.125,45.9498589 41.125,44.7220845 L41.125,22.2822926 C40.4887822,22.4116582 39.8442868,22.4815492 39.198,22.4912623 Z"></path></g></g></g></g></svg>',
        group: "clientes",
        can: "ROLE_MENU_PostoTrabalhoRondaExecucao",
        prefix: "mdi-handshake-outline",
        items: [
          {
            title: "PostoTrabalhoRondaLocais",
            prefix: "mdi-map-marker-path",
            link: "/dashboard/postoTrabalhoRondaLocais",
            can: "ROLE_PostoTrabalhoRondaLocal_List",
          },
          {
            title: "PostoTrabalhoRondaPlanejamentos",
            prefix: "mdi-calendar-clock-outline",
            link: "/dashboard/postoTrabalhoRondaPlanejamentos",
            can: "ROLE_PostoTrabalhoRondaPlanejamento_List",
          },
          {
            title: "PostoTrabalhoRondaExecucoes",
            prefix: "mdi-eye-outline",
            link: "/dashboard/postoTrabalhoRondaExecucoes",
            can: "ROLE_PostoTrabalhoRondaExecucao_List",
          },
        ],
      },

      {
        title: "NR1",
        active: false,
        action:
          '<svg width="12px" height="12px" viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>spaceship</title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1720.000000, -592.000000)" fill="#FFFFFF" fill-rule="nonzero"><g transform="translate(1716.000000, 291.000000)"><g transform="translate(4.000000, 301.000000)"><path class="color-background" d="M39.3,0.706666667 C38.9660984,0.370464027 38.5048767,0.192278529 38.0316667,0.216666667 C14.6516667,1.43666667 6.015,22.2633333 5.93166667,22.4733333 C5.68236407,23.0926189 5.82664679,23.8009159 6.29833333,24.2733333 L15.7266667,33.7016667 C16.2013871,34.1756798 16.9140329,34.3188658 17.535,34.065 C17.7433333,33.98 38.4583333,25.2466667 39.7816667,1.97666667 C39.8087196,1.50414529 39.6335979,1.04240574 39.3,0.706666667 Z M25.69,19.0233333 C24.7367525,19.9768687 23.3029475,20.2622391 22.0572426,19.7463614 C20.8115377,19.2304837 19.9992882,18.0149658 19.9992882,16.6666667 C19.9992882,15.3183676 20.8115377,14.1028496 22.0572426,13.5869719 C23.3029475,13.0710943 24.7367525,13.3564646 25.69,14.31 C26.9912731,15.6116662 26.9912731,17.7216672 25.69,19.0233333 L25.69,19.0233333 Z"></path><path class="color-background" d="M1.855,31.4066667 C3.05106558,30.2024182 4.79973884,29.7296005 6.43969145,30.1670277 C8.07964407,30.6044549 9.36054508,31.8853559 9.7979723,33.5253085 C10.2353995,35.1652612 9.76258177,36.9139344 8.55833333,38.11 C6.70666667,39.9616667 0,40 0,40 C0,40 0,33.2566667 1.855,31.4066667 Z"></path><path class="color-background" d="M17.2616667,3.90166667 C12.4943643,3.07192755 7.62174065,4.61673894 4.20333333,8.04166667 C3.31200265,8.94126033 2.53706177,9.94913142 1.89666667,11.0416667 C1.5109569,11.6966059 1.61721591,12.5295394 2.155,13.0666667 L5.47,16.3833333 C8.55036617,11.4946947 12.5559074,7.25476565 17.2616667,3.90166667 L17.2616667,3.90166667 Z" opacity="0.598539807"></path><path class="color-background" d="M36.0983333,22.7383333 C36.9280725,27.5056357 35.3832611,32.3782594 31.9583333,35.7966667 C31.0587397,36.6879974 30.0508686,37.4629382 28.9583333,38.1033333 C28.3033941,38.4890431 27.4704606,38.3827841 26.9333333,37.845 L23.6166667,34.53 C28.5053053,31.4496338 32.7452344,27.4440926 36.0983333,22.7383333 L36.0983333,22.7383333 Z" opacity="0.598539807"></path></g></g></g></g></svg>',
        group: "nr1",
        can: "ROLE_MENU_Nr1",
        prefix: "mdi-clipboard-text",
        items: [
          {
            title: "Nr1Topicos",
            prefix: "ni-ruler-pencil-box-multiple-outline",
            link: "/dashboard/nr1Topicos",
            can: "ROLE_Nr1Topico_List",
          },
          {
            title: "Nr1Campanhas",
            prefix: "mdi-bullhorn",
            link: "/dashboard/nr1Campanhas",
            can: "ROLE_Nr1Campanha_List",
          },
          {
            title: "Dashboard_NR1",
            prefix: "mdi-view-dashboard",
            link: "/dashboard/nr1Campanhas/dashboard",
            can: "ROLE_Nr1CampanhaDetalhado_List",
          },
          {
            title: "Dashboard_NR1_Graficos",
            prefix: "mdi-chart-bar",
            link: "/dashboard/nr1Campanhas/dashboard-graficos",
            can: "ROLE_Nr1Campanha_List",
          },
        ],
      },
      {
        title: "GCF",
        active: false,
        action:
          '<svg width="12px" height="12px" viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>safe</title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1720.000000, -592.000000)" fill="#FFFFFF" fill-rule="nonzero"><g transform="translate(1716.000000, 291.000000)"><g transform="translate(4.000000, 301.000000)"><path class="color-background" d="M6,7 L34,7 L34,29 L6,29 L6,7 Z M6,5 L34,5 C36.209139,5 38,6.790861 38,9 L38,29 C38,31.209139 36.209139,33 34,33 L6,33 C3.790861,33 2,31.209139 2,29 L2,9 C2,6.790861 3.790861,5 6,5 Z"></path><path class="color-background" d="M20,13 C23.3137085,13 26,15.6862915 26,19 C26,22.3137085 23.3137085,25 20,25 C16.6862915,25 14,22.3137085 14,19 C14,15.6862915 16.6862915,13 20,13 Z"></path><circle class="color-background" cx="20" cy="19" r="6"></circle><g transform="translate(20,19)"><path d="M0,-6 L0,-9" stroke="#111" stroke-width="2.5" stroke-linecap="round"/><path d="M0,6 L0,9" stroke="#111" stroke-width="2.5" stroke-linecap="round"/><path d="M-6,0 L-9,0" stroke="#111" stroke-width="2.5" stroke-linecap="round"/><path d="M6,0 L9,0" stroke="#111" stroke-width="2.5" stroke-linecap="round"/><circle cx="0" cy="0" r="2.5" fill="#111"/></g><path class="color-background" d="M12,30 L28,30" stroke="#FFFFFF" stroke-width="3" stroke-linecap="round"/></g></g></g></g></svg>',
        group: "GCF",
        can: "ROLE_Menu_CaixaForte",
        prefix: "mdi-map-marker-path",
        items: [
          {
            title: "CaixaForte",
            prefix: "mdi-order-bool-ascending-variant",
            link: "/dashboard/caixaForte",
            can: "ROLE_CaixaForte_List",
          },
          {
            title: "CaixaForteFechamento",
            prefix: "mdi-lock-check",
            link: "/dashboard/caixaForteFechamento",
            can: "ROLE_CaixaForteFechamento_List",
          },
          {
            title: "CaixaForteItem",
            prefix: "mdi-order-bool-ascending-variant",
            link: "/dashboard/caixaForteItem",
            can: "ROLE_CaixaForteItem_List",
          },
          {
            title: "CaixaForteEntradasPendentes",
            prefix: "mdi-clipboard-alert-outline",
            link: "/dashboard/caixaForte/entradasPendentes",
            can: "ROLE_CaixaForte_List",
          },
          {
            title: "CaixaForteAuditoria",
            prefix: "mdi-clipboard-search-outline",
            link: "/dashboard/caixaForteAuditoria",
            can: "ROLE_CaixaForteAuditoria_List",
          },
          {
            title: "CaixaForteSaldo",
            prefix: "mdi-chart-line",
            link: "/dashboard/caixaForteSaldo",
            can: "ROLE_CaixaForte_List",
          },
        ],
      },
      {
        title: "GTI",
        active: false,
        action:
          '<svg width="12px" height="12px" viewBox="0 0 43 36" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>credit-card</title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-2169.000000, -745.000000)" fill="#FFFFFF" fill-rule="nonzero"><g transform="translate(1716.000000, 291.000000)"><g transform="translate(453.000000, 454.000000)"><path class="color-background" d="M43,10.7482083 L43,3.58333333 C43,1.60354167 41.3964583,0 39.4166667,0 L3.58333333,0 C1.60354167,0 0,1.60354167 0,3.58333333 L0,10.7482083 L43,10.7482083 Z" opacity="0.593633743"></path><path class="color-background" d="M0,16.125 L0,32.25 C0,34.2297917 1.60354167,35.8333333 3.58333333,35.8333333 L39.4166667,35.8333333 C41.3964583,35.8333333 43,34.2297917 43,32.25 L43,16.125 L0,16.125 Z M19.7083333,26.875 L7.16666667,26.875 L7.16666667,23.2916667 L19.7083333,23.2916667 L19.7083333,26.875 Z M35.8333333,26.875 L28.6666667,26.875 L28.6666667,23.2916667 L35.8333333,23.2916667 L35.8333333,26.875 Z"></path></g></g></g></g></svg>',
        group: "GTI",
        can: "ROLE_MENU_Tesouraria",
        prefix: "mdi-map-marker-path",
        items: [
          {
            title: "TesourariaArea",
            prefix: "mdi-map-marker-radius",
            link: "/dashboard/tesourariaAreas",
            can: "ROLE_TesourariaArea_List",
          },
          {
            title: "Tesouraria",
            prefix: "mdi-account-cash",
            link: "/dashboard/tesourarias",
            can: "ROLE_Tesouraria_List",
          },
          {
            title: "TesourariaTurno",
            prefix: "mdi-clock-start",
            link: "/dashboard/tesourariaTurnos",
            can: "ROLE_TesourariaTurno_List",
          },
          {
            title: "OperacaoMoeda",
            prefix: "mdi-cash-multiple",
            link: "/dashboard/operacaoMoedas",
            can: "ROLE_OperacaoMoeda_List",
          },
          {
            title: "OperacaoMoedaCotacao",
            prefix: "mdi-currency-usd",
            link: "/dashboard/operacaoMoedaCotacoes",
            can: "ROLE_OperacaoMoedaCotacao_List",
          },
          {
            title: "TesourariaSaidasConfirmacaoPendente",
            prefix: "mdi-clock-outline",
            link: "/dashboard/tesourariaSaidasConfirmacaoPendente",
            can: "ROLE_TesourariaMovimentacao_List",
          },
          {
            title: "TesourariaMovimentacao",
            prefix: "mdi-swap-horizontal",
            link: "/dashboard/tesourariaMovimentacoes",
            can: "ROLE_TesourariaMovimentacao_List",
          },

          {
            title: "TesourariaRecontagem",
            prefix: "mdi-clipboard-check-outline",
            link: "/dashboard/tesourariaRecontagem",
            can: "ROLE_TesourariaRecontagem_Operator",
          },
          {
            title: "TesourariaDiferencaTipos",
            prefix: "mdi-scale-unbalanced",
            link: "/dashboard/tesourariaDiferencaTipos",
            can: "ROLE_TesourariaDiferencaTipo_List",
          },
          {
            title: "TesourariaSaldo",
            prefix: "mdi-chart-line",
            link: "/dashboard/tesourariaSaldo",
            can: "ROLE_Tesouraria_List",
          },
          {
            title: "TesourariaPosicao",
            prefix: "mdi-safe-square-outline",
            link: "/dashboard/tesourariaPosicao",
            can: "ROLE_Tesouraria_List",
          },
          {
            title: "TesourariaProdutividade",
            prefix: "mdi-chart-bar",
            link: "/dashboard/tesourariaProdutividade",
            can: "ROLE_TesourariaRecontagem_List",
          },
          {
            title: "TesourariaRecontagemBancada",
            prefix: "mdi-table-chair",
            link: "/dashboard/tesourariaRecontagemBancadas",
            can: "ROLE_TesourariaRecontagem_List",
          },
          {
            title: "Suprimentos",
            prefix: "mdi-order-bool-ascending-variant",
            link: "/dashboard/suprimentos",
            can: "ROLE_Suprimento_List",
          },
        ],
      },

      {
        title: "GCH",
        active: false,
        action:
          '<svg width="12px" height="12px" viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>key</title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1720.000000, -592.000000)" fill="#FFFFFF" fill-rule="nonzero"><g transform="translate(1716.000000, 291.000000)"><g transform="translate(4.000000, 301.000000)"><path class="color-background" d="M28,12 C31.866,12 35,15.134 35,19 C35,22.866 31.866,26 28,26 C24.134,26 21,22.866 21,19 C21,15.134 24.134,12 28,12 Z M28,15 C26.343,15 25,16.343 25,18 C25,19.657 26.343,21 28,21 C29.657,21 31,19.657 31,18 C31,16.343 29.657,15 28,15 Z"></path><path class="color-background" d="M15,25 L8,32 L8,35 L11,35 L18,28 L15,25 Z"></path><path class="color-background" d="M12,20 L20,28" stroke="#FFFFFF" stroke-width="3" stroke-linecap="round"></path></g></g></g></g></svg>',
        group: "GCH",
        can: "ROLE_MENU_Chaves",
        prefix: "mdi-map-marker-path",
        items: [
          {
            title: "TransporteChaves",
            prefix: "mdi-key-chain",
            link: "/dashboard/transporteChaves",
            can: "ROLE_TransporteChave_List",
          },
          {
            title: "TransporteChaveAuditoria",
            prefix: "mdi-clipboard-search-outline",
            link: "/dashboard/transporteChaveAuditoria",
            can: "ROLE_TransporteChaveAuditoria_List",
          },
          {
            title: "TransporteChaveMovimentacoes",
            prefix: "mdi-key-change",
            link: "/dashboard/transporteChaveMovimentacoes",
            can: "ROLE_TransporteChaveMovimentacao_List",
          },
          {
            title: "TransporteChaveMovimentacoesConsulta",
            prefix: "mdi-format-list-bulleted-square",
            link: "/dashboard/transporteChaveMovimentacoes/consulta",
            can: "ROLE_TransporteChaveMovimentacao_List",
          },
        ],
      },

      {
        title: "GAC",
        active: false,
        action:
          '<svg width="12px" height="12px" viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>gun</title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1720.000000, -592.000000)" fill="#FFFFFF" fill-rule="nonzero"><g transform="translate(1716.000000, 291.000000)"><g transform="translate(4.000000, 301.000000)"><path class="color-background" d="M5,27 L5,20 L11,20 L11,13 L28,13 L31,11 L37,11 L37,19 L31,19 L28,21 L11,21 L11,27 L5,27 z"></path><path class="color-background" d="M13,20.5 L13,23 L14.5,24.5 L16.5,24 L16,21.5 L13.5,20.5 z"></path></g></g></g></g></svg>',
        group: "GAC",
        can: "ROLE_MENU_ArmasColetes",
        prefix: "mdi-map-marker-path",
        items: [
          {
            title: "ArmaFogos",
            prefix: "mdi-pistol",
            link: "/dashboard/armaFogos",
            can: "ROLE_ArmaFogo_List",
          },
          {
            title: "ArmaFogoAuditoria",
            prefix: "mdi-clipboard-search-outline",
            link: "/dashboard/armaFogoAuditoria",
            can: "ROLE_ArmaFogoAuditoria_List",
          },
          {
            title: "ArmaFogoManutencoes",
            prefix: "mdi-tools",
            link: "/dashboard/armaFogoManutencoes",
            can: "ROLE_ArmaFogoManutencao_List",
          },
          {
            title: "ArmaFogoMunicoes",
            prefix: "mdi-ammunition",
            link: "/dashboard/armaFogoMunicoes",
            can: "ROLE_ArmaFogoMunicao_List",
          },
          {
            title: "ArmaFogoMunicaoMovimentacoes",
            prefix: "mdi-swap-horizontal-bold",
            link: "/dashboard/armaFogoMunicaoMovimentacoes",
            can: "ROLE_ArmaFogoMunicaoMovimentacao_List",
          },
          {
            title: "ColeteBalisticos",
            prefix: "mdi-shield-half-full",
            link: "/dashboard/coleteBalisticos",
            can: "ROLE_ColeteBalistico_List",
          },
          {
            title: "ArmaFogoColeteBalisticoMovimentacoes",
            prefix: "mdi-shield-sword-outline",
            link: "/dashboard/armaFogoColeteBalisticoMovimentacoes",
            can: "ROLE_MovimentacaoArmaFogoColeteBalistico_List",
          },
          {
            title: "ArmaFogoColeteBalisticoMovimentacoesConsulta",
            prefix: "mdi-format-list-bulleted-square",
            link: "/dashboard/armaFogoColeteBalisticoMovimentacoes/consulta",
            can: "ROLE_MovimentacaoArmaFogoColeteBalistico_List",
          },
        ],
      },

      {
        title: "Tarefas",
        active: false,
        action:
          '<svg width="12px" height="12px" viewBox="0 0 43 36" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>credit-card</title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-2169.000000, -745.000000)" fill="#FFFFFF" fill-rule="nonzero"><g transform="translate(1716.000000, 291.000000)"><g transform="translate(453.000000, 454.000000)"><path class="color-background" d="M43,10.7482083 L43,3.58333333 C43,1.60354167 41.3964583,0 39.4166667,0 L3.58333333,0 C1.60354167,0 0,1.60354167 0,3.58333333 L0,10.7482083 L43,10.7482083 Z" opacity="0.593633743"></path><path class="color-background" d="M0,16.125 L0,32.25 C0,34.2297917 1.60354167,35.8333333 3.58333333,35.8333333 L39.4166667,35.8333333 C41.3964583,35.8333333 43,34.2297917 43,32.25 L43,16.125 L0,16.125 Z M19.7083333,26.875 L7.16666667,26.875 L7.16666667,23.2916667 L19.7083333,23.2916667 L19.7083333,26.875 Z M35.8333333,26.875 L28.6666667,26.875 L28.6666667,23.2916667 L35.8333333,23.2916667 L35.8333333,26.875 Z"></path></g></g></g></g></svg>',
        group: "Tarefas",
        can: "ROLE_MENU_Tarefas",
        prefix: "mdi-map-marker-path",
        items: [
          {
            title: "TarefaClassificacaoAgrupamento",
            prefix: "mdi-select-group",
            link: "/dashboard/tarefaClassificacaoAgrupamento",
            can: "ROLE_TarefaClassificacaoAgrupamento_List",
          },
          {
            title: "TarefaClassificacao",
            prefix: "mdi-order-bool-ascending-variant",
            link: "/dashboard/tarefaClassificacao",
            can: "ROLE_TarefaClassificacao_List",
          },
          {
            title: "TarefaSolicitacao",
            prefix: "mdi-order-bool-ascending-variant",
            link: "/dashboard/tarefaSolicitacao",
            can: "ROLE_TarefaSolicitacao_List",
          },
          {
            title: "TarefaExecucao",
            prefix: "mdi-order-bool-ascending-variant",
            link: "/dashboard/tarefaExecucao",
            can: "ROLE_TarefaExecucao_List",
          },
          {
            title: "TarefaExecucaoItem",
            prefix: "mdi-order-bool-ascending-variant",
            link: "/dashboard/tarefaExecucao/acompanhamento",
            can: "ROLE_TarefaExecucaoItem_List",
          },
          {
            title: "TarefaExecucaoPeriodo",
            prefix: "mdi-order-bool-ascending-variant",
            link: "/dashboard/tarefaExecucao/acompanhamento/periodo",
            can: "ROLE_TarefaExecucaoItem_List",
          },
        ],
      },

      {
        title: "Contabilidade",
        active: false,
        action:
          '<svg width="12px" height="12px" viewBox="0 0 43 36" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>credit-card</title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-2169.000000, -745.000000)" fill="#FFFFFF" fill-rule="nonzero"><g transform="translate(1716.000000, 291.000000)"><g transform="translate(453.000000, 454.000000)"><path class="color-background" d="M43,10.7482083 L43,3.58333333 C43,1.60354167 41.3964583,0 39.4166667,0 L3.58333333,0 C1.60354167,0 0,1.60354167 0,3.58333333 L0,10.7482083 L43,10.7482083 Z" opacity="0.593633743"></path><path class="color-background" d="M0,16.125 L0,32.25 C0,34.2297917 1.60354167,35.8333333 3.58333333,35.8333333 L39.4166667,35.8333333 C41.3964583,35.8333333 43,34.2297917 43,32.25 L43,16.125 L0,16.125 Z M19.7083333,26.875 L7.16666667,26.875 L7.16666667,23.2916667 L19.7083333,23.2916667 L19.7083333,26.875 Z M35.8333333,26.875 L28.6666667,26.875 L28.6666667,23.2916667 L35.8333333,23.2916667 L35.8333333,26.875 Z"></path></g></g></g></g></svg>',
        group: "contabilidade",
        can: "ROLE_MENU_Contabilidade",
        prefix: "mdi-cash",
        items: [
          {
            title: "lancamentosContabeis",
            prefix: "mdi-finance",
            link: "/dashboard/lancamentocontabil",
            can: "ROLE_LancamentoContabil_Export",
          },
        ],
      },

      {
        title: "Roteirizador",
        active: false,
        action:
          '<svg width="12px" height="12px" viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>spaceship</title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1720.000000, -592.000000)" fill="#FFFFFF" fill-rule="nonzero"><g transform="translate(1716.000000, 291.000000)"><g transform="translate(4.000000, 301.000000)"><path class="color-background" d="M39.3,0.706666667 C38.9660984,0.370464027 38.5048767,0.192278529 38.0316667,0.216666667 C14.6516667,1.43666667 6.015,22.2633333 5.93166667,22.4733333 C5.68236407,23.0926189 5.82664679,23.8009159 6.29833333,24.2733333 L15.7266667,33.7016667 C16.2013871,34.1756798 16.9140329,34.3188658 17.535,34.065 C17.7433333,33.98 38.4583333,25.2466667 39.7816667,1.97666667 C39.8087196,1.50414529 39.6335979,1.04240574 39.3,0.706666667 Z M25.69,19.0233333 C24.7367525,19.9768687 23.3029475,20.2622391 22.0572426,19.7463614 C20.8115377,19.2304837 19.9992882,18.0149658 19.9992882,16.6666667 C19.9992882,15.3183676 20.8115377,14.1028496 22.0572426,13.5869719 C23.3029475,13.0710943 24.7367525,13.3564646 25.69,14.31 C26.9912731,15.6116662 26.9912731,17.7216672 25.69,19.0233333 L25.69,19.0233333 Z"></path><path class="color-background" d="M1.855,31.4066667 C3.05106558,30.2024182 4.79973884,29.7296005 6.43969145,30.1670277 C8.07964407,30.6044549 9.36054508,31.8853559 9.7979723,33.5253085 C10.2353995,35.1652612 9.76258177,36.9139344 8.55833333,38.11 C6.70666667,39.9616667 0,40 0,40 C0,40 0,33.2566667 1.855,31.4066667 Z"></path><path class="color-background" d="M17.2616667,3.90166667 C12.4943643,3.07192755 7.62174065,4.61673894 4.20333333,8.04166667 C3.31200265,8.94126033 2.53706177,9.94913142 1.89666667,11.0416667 C1.5109569,11.6966059 1.61721591,12.5295394 2.155,13.0666667 L5.47,16.3833333 C8.55036617,11.4946947 12.5559074,7.25476565 17.2616667,3.90166667 L17.2616667,3.90166667 Z" opacity="0.598539807"></path><path class="color-background" d="M36.0983333,22.7383333 C36.9280725,27.5056357 35.3832611,32.3782594 31.9583333,35.7966667 C31.0587397,36.6879974 30.0508686,37.4629382 28.9583333,38.1033333 C28.3033941,38.4890431 27.4704606,38.3827841 26.9333333,37.845 L23.6166667,34.53 C28.5053053,31.4496338 32.7452344,27.4440926 36.0983333,22.7383333 L36.0983333,22.7383333 Z" opacity="0.598539807"></path></g></g></g></g></svg>',
        group: "operacoes",
        can: "ROLE_MENU_Roteirizador",
        prefix: "mdi-map-marker-path",
        items: [
          {
            title: "RoteirizadorParametro",
            prefix: "mdi-finance",
            link: "/dashboard/roteirizadorParametro",
            can: "ROLE_RoteirizadorParametro_List",
          },
          {
            title: "Roteirizacao",
            prefix: "mdi-finance",
            link: "/dashboard/roteirizacao",
            can: "ROLE_Roteirizador_PlanejamentoRotas",
          },
        ],
      },

      /*{
        title: "GTV_Gestao_Trasporte_Valores",
        active: false,
        action:
          '<svg width="12px" height="12px" viewBox="0 0 43 36" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>credit-card</title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-2169.000000, -745.000000)" fill="#FFFFFF" fill-rule="nonzero"><g transform="translate(1716.000000, 291.000000)"><g transform="translate(453.000000, 454.000000)"><path class="color-background" d="M43,10.7482083 L43,3.58333333 C43,1.60354167 41.3964583,0 39.4166667,0 L3.58333333,0 C1.60354167,0 0,1.60354167 0,3.58333333 L0,10.7482083 L43,10.7482083 Z" opacity="0.593633743"></path><path class="color-background" d="M0,16.125 L0,32.25 C0,34.2297917 1.60354167,35.8333333 3.58333333,35.8333333 L39.4166667,35.8333333 C41.3964583,35.8333333 43,34.2297917 43,32.25 L43,16.125 L0,16.125 Z M19.7083333,26.875 L7.16666667,26.875 L7.16666667,23.2916667 L19.7083333,23.2916667 L19.7083333,26.875 Z M35.8333333,26.875 L28.6666667,26.875 L28.6666667,23.2916667 L35.8333333,23.2916667 L35.8333333,26.875 Z"></path></g></g></g></g></svg>',
        group: "contabilidade",
        can: "ROLE_MENU_Contabilidade",
        prefix: "mdi-cash",
        items: [
          {
            title: "lancamentosContabeis",
            prefix: "mdi-finance",
            link: "/dashboard/lancamentocontabil",
            can: "ROLE_LancamentoContabil_Export",
          },
        ],
      },*/

      {
        title: "EmailMarketing",
        active: false,
        action:
          '<svg width="12px" height="12px" viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>spaceship</title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1720.000000, -592.000000)" fill="#FFFFFF" fill-rule="nonzero"><g transform="translate(1716.000000, 291.000000)"><g transform="translate(4.000000, 301.000000)"><path class="color-background" d="M39.3,0.706666667 C38.9660984,0.370464027 38.5048767,0.192278529 38.0316667,0.216666667 C14.6516667,1.43666667 6.015,22.2633333 5.93166667,22.4733333 C5.68236407,23.0926189 5.82664679,23.8009159 6.29833333,24.2733333 L15.7266667,33.7016667 C16.2013871,34.1756798 16.9140329,34.3188658 17.535,34.065 C17.7433333,33.98 38.4583333,25.2466667 39.7816667,1.97666667 C39.8087196,1.50414529 39.6335979,1.04240574 39.3,0.706666667 Z M25.69,19.0233333 C24.7367525,19.9768687 23.3029475,20.2622391 22.0572426,19.7463614 C20.8115377,19.2304837 19.9992882,18.0149658 19.9992882,16.6666667 C19.9992882,15.3183676 20.8115377,14.1028496 22.0572426,13.5869719 C23.3029475,13.0710943 24.7367525,13.3564646 25.69,14.31 C26.9912731,15.6116662 26.9912731,17.7216672 25.69,19.0233333 L25.69,19.0233333 Z"></path><path class="color-background" d="M1.855,31.4066667 C3.05106558,30.2024182 4.79973884,29.7296005 6.43969145,30.1670277 C8.07964407,30.6044549 9.36054508,31.8853559 9.7979723,33.5253085 C10.2353995,35.1652612 9.76258177,36.9139344 8.55833333,38.11 C6.70666667,39.9616667 0,40 0,40 C0,40 0,33.2566667 1.855,31.4066667 Z"></path><path class="color-background" d="M17.2616667,3.90166667 C12.4943643,3.07192755 7.62174065,4.61673894 4.20333333,8.04166667 C3.31200265,8.94126033 2.53706177,9.94913142 1.89666667,11.0416667 C1.5109569,11.6966059 1.61721591,12.5295394 2.155,13.0666667 L5.47,16.3833333 C8.55036617,11.4946947 12.5559074,7.25476565 17.2616667,3.90166667 L17.2616667,3.90166667 Z" opacity="0.598539807"></path><path class="color-background" d="M36.0983333,22.7383333 C36.9280725,27.5056357 35.3832611,32.3782594 31.9583333,35.7966667 C31.0587397,36.6879974 30.0508686,37.4629382 28.9583333,38.1033333 C28.3033941,38.4890431 27.4704606,38.3827841 26.9333333,37.845 L23.6166667,34.53 C28.5053053,31.4496338 32.7452344,27.4440926 36.0983333,22.7383333 L36.0983333,22.7383333 Z" opacity="0.598539807"></path></g></g></g></g></svg>',
        can: "ROLE_MENU_Marketing",
        group: "Marketing",
        prefix: "mdi-email-outline",
        items: [
          {
            title: "Enviar_email",
            prefix: "mdi-email-outline",
            link: "/dashboard/enviarEmailMarketing",
            can: "ROLE_Marketing_Insert",
            icon: "mdi-email-outline",
          },
          {
            title: "Listagem",
            prefix: "mdi-email-outline",
            link: "/dashboard/EmailMarketing",
            can: "ROLE_Marketing_List",
            icon: "mdi-archive-outline",
          },
        ],
      },

      {
        title: "GeradorRelatorio",
        active: false,
        action:
          '<svg width="12px" height="12px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path class="color-background" fill-rule="evenodd" d="M4 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8.83a2 2 0 0 0-.59-1.42l-4.82-4.82A2 2 0 0 0 15.17 2H4Zm3 15a1 1 0 1 0 2 0v-3a1 1 0 1 0-2 0v3Zm5 1a1 1 0 0 1-1-1v-6a1 1 0 1 1 2 0v6a1 1 0 0 1-1 1Zm3-1a1 1 0 1 0 2 0V9a1 1 0 1 0-2 0v8Z" clip-rule="evenodd"/></svg>',
        group: "geradorRelatorio",
        can: "ROLE_MENU_GeradorRelatorio",
        prefix: "mdi-file-chart-outline",
        items: [
          {
            title: "Relatorios_salvos",
            prefix: "mdi-database-search-outline",
            link: "/dashboard/geradoresRelatorios",
            can: "ROLE_GeradorRelatorio_List",
          },
          {
            title: "Executar_consulta_avulsa",
            prefix: "mdi-play-circle-outline",
            link: "/dashboard/geradoresRelatorios/executar",
            can: "ROLE_GeradorRelatorio_Execute",
          },
        ],
      },

      {
        title: "Software",
        active: false,
        action:
          '<svg width="12px" height="12px" viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>spaceship</title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1720.000000, -592.000000)" fill="#FFFFFF" fill-rule="nonzero"><g transform="translate(1716.000000, 291.000000)"><g transform="translate(4.000000, 301.000000)"><path class="color-background" d="M39.3,0.706666667 C38.9660984,0.370464027 38.5048767,0.192278529 38.0316667,0.216666667 C14.6516667,1.43666667 6.015,22.2633333 5.93166667,22.4733333 C5.68236407,23.0926189 5.82664679,23.8009159 6.29833333,24.2733333 L15.7266667,33.7016667 C16.2013871,34.1756798 16.9140329,34.3188658 17.535,34.065 C17.7433333,33.98 38.4583333,25.2466667 39.7816667,1.97666667 C39.8087196,1.50414529 39.6335979,1.04240574 39.3,0.706666667 Z M25.69,19.0233333 C24.7367525,19.9768687 23.3029475,20.2622391 22.0572426,19.7463614 C20.8115377,19.2304837 19.9992882,18.0149658 19.9992882,16.6666667 C19.9992882,15.3183676 20.8115377,14.1028496 22.0572426,13.5869719 C23.3029475,13.0710943 24.7367525,13.3564646 25.69,14.31 C26.9912731,15.6116662 26.9912731,17.7216672 25.69,19.0233333 L25.69,19.0233333 Z"></path><path class="color-background" d="M1.855,31.4066667 C3.05106558,30.2024182 4.79973884,29.7296005 6.43969145,30.1670277 C8.07964407,30.6044549 9.36054508,31.8853559 9.7979723,33.5253085 C10.2353995,35.1652612 9.76258177,36.9139344 8.55833333,38.11 C6.70666667,39.9616667 0,40 0,40 C0,40 0,33.2566667 1.855,31.4066667 Z"></path><path class="color-background" d="M17.2616667,3.90166667 C12.4943643,3.07192755 7.62174065,4.61673894 4.20333333,8.04166667 C3.31200265,8.94126033 2.53706177,9.94913142 1.89666667,11.0416667 C1.5109569,11.6966059 1.61721591,12.5295394 2.155,13.0666667 L5.47,16.3833333 C8.55036617,11.4946947 12.5559074,7.25476565 17.2616667,3.90166667 L17.2616667,3.90166667 Z" opacity="0.598539807"></path><path class="color-background" d="M36.0983333,22.7383333 C36.9280725,27.5056357 35.3832611,32.3782594 31.9583333,35.7966667 C31.0587397,36.6879974 30.0508686,37.4629382 28.9583333,38.1033333 C28.3033941,38.4890431 27.4704606,38.3827841 26.9333333,37.845 L23.6166667,34.53 C28.5053053,31.4496338 32.7452344,27.4440926 36.0983333,22.7383333 L36.0983333,22.7383333 Z" opacity="0.598539807"></path></g></g></g></g></svg>',
        group: "software",
        can: "ROLE_MENU_Software",
        prefix: "mdi-devices",
        items: [
          {
            title: "Inquilinos",
            prefix: "mdi-account-tie-voice",
            link: "/dashboard/inquilinos",
            can: "ROLE_Inquilino_List",
          },
          {
            title: "permissoes",
            prefix: "mdi-key-outline",
            link: "/dashboard/permissoes",
            can: "ROLE_Permissao_List",
          },
          {
            title: "usuarioPerfis",
            prefix: "mdi-account-key-outline",
            link: "/dashboard/usuarioPerfis",
            can: "ROLE_UsuarioPerfil_List",
          },
          {
            title: "feriados",
            prefix: "mdi-sunglasses",
            link: "/dashboard/feriados",
            can: "ROLE_Feriado_List",
          },
          {
            title: "CertificadosA1",
            prefix: "mdi-certificate",
            link: "/dashboard/certificadosA1",
            can: "ROLE_CertificadoA1_List",
          },
          {
            title: "PontoFacultativo",
            prefix: "mdi-sunglasses",
            link: "/dashboard/pontosFacultativo",
            can: "ROLE_PontoFacultativo_List",
          },
          {
            title: "LogAuditoria",
            prefix: "mdi-clipboard-text-clock-outline",
            link: "/dashboard/logTransacoes",
            can: "ROLE_LogTransacao_List",
          },
          {
            title: "OperacoesPendentesTransacoes",
            prefix: "mdi-cloud-alert-outline",
            link: "/dashboard/operacoesPendentesTransacoes",
            can: "ROLE_OperacaoPendenteTransacao_List",
          },
          {
            title: "WhatsappProcessos",
            prefix: "mdi-whatsapp",
            link: "/dashboard/whatsappProcessos",
            can: "ROLE_WhatsappProcesso_List",
          },
          {
            title: "FaceDescriptors",
            prefix: "mdi-face-recognition",
            link: "/dashboard/faceDescriptors",
            can: "ROLE_FaceDescriptor_List",
          },
          {
            title: "D4SignConfiguracao" /*titulo*/,
            prefix: "mdi-draw-pen" /*ícone*/,
            link: "/dashboard/d4signConfiguracao" /*Href*/,
            can: "ROLE_D4SignConfig_Update" /*Can*/,
          },
        ],
      },

      {
        title: "Locais",
        active: false,
        action:
          '<svg width="12px" height="12px" viewBox="0 0 45 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>shop </title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1716.000000, -439.000000)" fill="#FFFFFF" fill-rule="nonzero"><g transform="translate(1716.000000, 291.000000)"><g transform="translate(0.000000, 148.000000)"><path class="color-background" d="M46.7199583,10.7414583 L40.8449583,0.949791667 C40.4909749,0.360605034 39.8540131,0 39.1666667,0 L7.83333333,0 C7.1459869,0 6.50902508,0.360605034 6.15504167,0.949791667 L0.280041667,10.7414583 C0.0969176761,11.0460037 -1.23209662e-05,11.3946378 -1.23209662e-05,11.75 C-0.00758042603,16.0663731 3.48367543,19.5725301 7.80004167,19.5833333 L7.81570833,19.5833333 C9.75003686,19.5882688 11.6168794,18.8726691 13.0522917,17.5760417 C16.0171492,20.2556967 20.5292675,20.2556967 23.494125,17.5760417 C26.4604562,20.2616016 30.9794188,20.2616016 33.94575,17.5760417 C36.2421905,19.6477597 39.5441143,20.1708521 42.3684437,18.9103691 C45.1927731,17.649886 47.0084685,14.8428276 47.0000295,11.75 C47.0000295,11.3946378 46.9030823,11.0460037 46.7199583,10.7414583 Z" opacity="0.598981585"></path><path class="color-background" d="M39.198,22.4912623 C37.3776246,22.4928106 35.5817531,22.0149171 33.951625,21.0951667 L33.92225,21.1107282 C31.1430221,22.6838032 27.9255001,22.9318916 24.9844167,21.7998837 C24.4750389,21.605469 23.9777983,21.3722567 23.4960833,21.1018359 L23.4745417,21.1129513 C20.6961809,22.6871153 17.4786145,22.9344611 14.5386667,21.7998837 C14.029926,21.6054643 13.533337,21.3722507 13.0522917,21.1018359 C11.4250962,22.0190609 9.63246555,22.4947009 7.81570833,22.4912623 C7.16510551,22.4842162 6.51607673,22.4173045 5.875,22.2911849 L5.875,44.7220845 C5.875,45.9498589 6.7517757,46.9451667 7.83333333,46.9451667 L19.5833333,46.9451667 L19.5833333,33.6066734 L27.4166667,33.6066734 L27.4166667,46.9451667 L39.1666667,46.9451667 C40.2482243,46.9451667 41.125,45.9498589 41.125,44.7220845 L41.125,22.2822926 C40.4887822,22.4116582 39.8442868,22.4815492 39.198,22.4912623 Z"></path></g></g></g></g></svg>',
        group: "locais",
        can: "ROLE_MENU_Locais",
        prefix: "mdi-compass-rose",
        items: [
          {
            title: "Paises",
            prefix: "mdi-bank",
            link: "/dashboard/paises",
            can: "ROLE_Pais_List",
          },
          {
            title: "Estados",
            prefix: "mdi-map-marker-path",
            link: "/dashboard/estados",
            can: "ROLE_Estado_List",
          },
          {
            title: "Cidades",
            prefix: "mdi-city",
            link: "/dashboard/cidades",
            can: "ROLE_Cidade_List",
          },
        ],
      },

      {
        title: "Suporte",
        active: false,
        action:
          '<svg width="12px" height="12px" viewBox="0 0 45 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>shop </title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1716.000000, -439.000000)" fill="#FFFFFF" fill-rule="nonzero"><g transform="translate(1716.000000, 291.000000)"><g transform="translate(0.000000, 148.000000)"><path class="color-background" d="M46.7199583,10.7414583 L40.8449583,0.949791667 C40.4909749,0.360605034 39.8540131,0 39.1666667,0 L7.83333333,0 C7.1459869,0 6.50902508,0.360605034 6.15504167,0.949791667 L0.280041667,10.7414583 C0.0969176761,11.0460037 -1.23209662e-05,11.3946378 -1.23209662e-05,11.75 C-0.00758042603,16.0663731 3.48367543,19.5725301 7.80004167,19.5833333 L7.81570833,19.5833333 C9.75003686,19.5882688 11.6168794,18.8726691 13.0522917,17.5760417 C16.0171492,20.2556967 20.5292675,20.2556967 23.494125,17.5760417 C26.4604562,20.2616016 30.9794188,20.2616016 33.94575,17.5760417 C36.2421905,19.6477597 39.5441143,20.1708521 42.3684437,18.9103691 C45.1927731,17.649886 47.0084685,14.8428276 47.0000295,11.75 C47.0000295,11.3946378 46.9030823,11.0460037 46.7199583,10.7414583 Z" opacity="0.598981585"></path><path class="color-background" d="M39.198,22.4912623 C37.3776246,22.4928106 35.5817531,22.0149171 33.951625,21.0951667 L33.92225,21.1107282 C31.1430221,22.6838032 27.9255001,22.9318916 24.9844167,21.7998837 C24.4750389,21.605469 23.9777983,21.3722567 23.4960833,21.1018359 L23.4745417,21.1129513 C20.6961809,22.6871153 17.4786145,22.9344611 14.5386667,21.7998837 C14.029926,21.6054643 13.533337,21.3722507 13.0522917,21.1018359 C11.4250962,22.0190609 9.63246555,22.4947009 7.81570833,22.4912623 C7.16510551,22.4842162 6.51607673,22.4173045 5.875,22.2911849 L5.875,44.7220845 C5.875,45.9498589 6.7517757,46.9451667 7.83333333,46.9451667 L19.5833333,46.9451667 L19.5833333,33.6066734 L27.4166667,33.6066734 L27.4166667,46.9451667 L39.1666667,46.9451667 C40.2482243,46.9451667 41.125,45.9498589 41.125,44.7220845 L41.125,22.2822926 C40.4887822,22.4116582 39.8442868,22.4815492 39.198,22.4912623 Z"></path></g></g></g></g></svg>',
        group: "locais",
        can: "ROLE_MENU_Suporte",
        prefix: "mdi-compass-rose",
        supportMenuScope: "PROJETO",
        items: [
          {
            title: "SuporteDashboard",
            prefix: "mdi-chart-box-outline",
            link: "/dashboard/suporte/dashboard",
            can: "",
            supportPermission: "LIST",
            supportScope: "PROJETO",
          },
          {
            title: "SuporteTickets",
            prefix: "mdi-format-list-bulleted",
            link: "/dashboard/suporte/tickets",
            can: "",
            supportPermission: "LIST",
            supportScope: "PROJETO",
          },
          {
            title: "SuporteAtendimento",
            prefix: "mdi-headset",
            link: "/dashboard/suporte/atendimento",
            can: "",
            supportPermission: "ATENDIMENTO",
            supportScope: "PROJETO",
          },
          {
            title: "TutorialProcessos",
            prefix: "fas fa-robot",
            link: "/dashboard/suporte/tutoriais",
            can: "",
            supportPermission: "ATENDIMENTO",
            projectSupportOnly: true,
          },
          {
            title: "SupportTeamMembers",
            prefix: "mdi-account-group",
            link: "/dashboard/suporte/equipe",
            can: "ROLE_SupportTeamMember_List",
            supportPermission: "OPERATOR",
            supportScope: "PROJETO",
          },
          {
            title: "SupportSubjects",
            prefix: "mdi-tag-multiple-outline",
            link: "/dashboard/suporte/assuntos",
            can: "ROLE_SupportSubject_List",
            supportPermission: "OPERATOR",
            supportScope: "PROJETO",
          },
          {
            title: "SupportHorarioAtendimento",
            prefix: "mdi-clock-outline",
            link: "/dashboard/suporte/horario-atendimento",
            can: "ROLE_SupportHorarioAtendimento_List",
            supportPermission: "OPERATOR",
            supportScope: "PROJETO",
          },
        ],
      },
      {
        title: "SuporteInterno",
        active: false,
        action:
          '<svg width="12px" height="12px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>support</title><path class="color-background" d="M12 1a10 10 0 0 0-10 10v6a3 3 0 0 0 3 3h3v-8H4v-1a8 8 0 0 1 16 0v1h-4v8h4v1h-8v2h7a3 3 0 0 0 3-3v-9A10 10 0 0 0 12 1Z"/></svg>',
        group: "support-internal",
        can: "",
        prefix: "mdi-headset",
        supportMenuScope: "INTERNO",
        items: [
          {
            title: "SuporteInternoDashboard",
            prefix: "mdi-chart-box-outline",
            link: "/dashboard/suporte-interno/dashboard",
            can: "",
            supportPermission: "LIST",
            supportScope: "INTERNO",
          },
          {
            title: "SuporteInternoTickets",
            prefix: "mdi-format-list-bulleted",
            link: "/dashboard/suporte-interno/tickets",
            can: "",
            supportPermission: "LIST",
            supportScope: "INTERNO",
          },
          {
            title: "SuporteAtendimentoInterno",
            prefix: "mdi-account-group-outline",
            link: "/dashboard/suporte-interno/atendimento",
            can: "",
            supportPermission: "ATENDIMENTO",
            supportScope: "INTERNO",
          },
          {
            title: "SupportTeamMembers",
            prefix: "mdi-account-group",
            link: "/dashboard/suporte-interno/equipe",
            can: "ROLE_SupportTeamMember_List",
            supportPermission: "OPERATOR",
            supportScope: "INTERNO",
          },
          {
            title: "SupportSubjects",
            prefix: "mdi-tag-multiple-outline",
            link: "/dashboard/suporte-interno/assuntos",
            can: "ROLE_SupportSubject_List",
            supportPermission: "OPERATOR",
            supportScope: "INTERNO",
          },
          {
            title: "SupportHorarioAtendimento",
            prefix: "mdi-clock-outline",
            link: "/dashboard/suporte-interno/horario-atendimento",
            can: "ROLE_SupportHorarioAtendimento_List",
            supportPermission: "OPERATOR",
            supportScope: "INTERNO",
          },
          {
            title: "SupportAiConfiguracao",
            prefix: "mdi-robot-outline",
            link: "/dashboard/suporte-interno/atendimento-ia",
            can: "ROLE_SupportAiConfiguracao_List",
            supportPermission: "OPERATOR",
            supportScope: "INTERNO",
          },
        ],
      },
      {
        title: "SuporteCliente",
        active: false,
        action:
          '<svg width="12px" height="12px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>tickets</title><path class="color-background" d="M22 10V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v4a2 2 0 0 1 0 4v4a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-4a2 2 0 0 1 0-4Zm-9 7.5h-2v-2h2v2Zm0-4.5h-2v-2h2v2Zm0-4.5h-2v-2h2v2Z"/></svg>',
        group: "support-client",
        can: "ROLE_MENU_SuporteCliente",
        prefix: "mdi-ticket-outline",
        hideWhenEmpty: true,
        items: [
          {
            title: "SuporteClienteDashboard",
            prefix: "mdi-chart-box-outline",
            link: "/dashboard/chamados/dashboard",
            can: "ROLE_SuporteCliente_List",
          },
          {
            title: "SuporteClienteChamados",
            prefix: "mdi-ticket-confirmation-outline",
            link: "/dashboard/chamados",
            can: "ROLE_SuporteCliente_List",
          },
        ],
      },
    ],
  }),

  computed: {
    ...mapState(["barColor", "barImage"]),
    whiteLabelBrand() {
      return resolveAppWhiteLabelBrand();
    },
    isWhiteLabelClient() {
      return isClientWhiteLabel(this.whiteLabelBrand);
    },
    currentTenant() {
      return resolveCurrentTenant(this.$store?.state || {});
    },
    hasInternalSupportOption() {
      return hasInternalSupport(this.currentTenant);
    },
    internalSupportButtonLabel() {
      return internalSupportLabel(this.currentTenant);
    },
    hasProjectSupportAccess() {
      return hasProjectSupportPermission(this.$store?.state || {});
    },
    hasInternalSupportAccess() {
      return (
        this.hasInternalSupportOption &&
        hasInternalSupportPermission(this.$store?.state || {})
      );
    },
    isOrgaoPublico() {
      return this.$store?.state?.inquilino?.tipoContratacao === "ORGAOPUBLICO";
    },
    computedItems() {
      const permissions = this.$store.state.permissoes || [];

      return this.items
        .filter(
          (item) =>
            item &&
            hasPermission(item.can, permissions) &&
            (item.group !== "CLP" ||
              podeOportunidades(this.$store.state)) &&
            (!item.hideWhenEmpty ||
              this.visibleMenuChildren(item.items).length > 0) &&
            (!item.supportMenuScope ||
              this.hasSupportMenuAccess(item.supportMenuScope)) &&
            String(item.title || "").length > 1,
        )
        .map((item) => {
          const visibleItem = item.supportMenuScope
            ? { ...item, items: this.visibleMenuChildren(item.items) }
            : item;

          if (
            !this.isOrgaoPublico ||
            !["clientes", "pessoal", "ponto", "beneficio"].includes(item.group)
          ) {
            return visibleItem;
          }

          const titulosOrgaoPublico = {
            "/dashboard/clientes": "Lotacoes",
            "/dashboard/postoTrabalhos": "LocalTrabalho",
            "/dashboard/funcionarios": "Servidores",
            "/dashboard/BeneficioAnalise/cliente": "BeneficioAnaliseLotacao",
            "/dashboard/funcionarioRegistrador": "ServidorRegistrador",
            "/dashboard/funcionarioPontoWeb": "ServidorPontoWeb",
          };

          return {
            ...visibleItem,
            items: visibleItem.items.map((child) =>
              titulosOrgaoPublico[child.link]
                ? { ...child, title: titulosOrgaoPublico[child.link] }
                : child,
            ),
          };
        });
    },
    filteredItems() {
      return this.computedItems;
    },
    // A barra de atalhos recebe só os itens que o menu mostra (permissão, módulo contratado,
    // escopo do suporte, eSocial): sem isso, ela oferecia telas que a rota recusa.
    navigationMenuItems() {
      return this.visibleMenuTree(this.computedItems);
    },
    drawerClasses() {
      return this.$vuetify.breakpoint.mobile
        ? "app-drawer app-drawer--mobile bg-white"
        : "app-drawer my-4 ms-4 border-radius-lg";
    },
    drawerWidth() {
      return this.$vuetify.breakpoint.mobile ? "86vw" : undefined;
    },

    profile() {
      return {
        avatar: true,
        title: this.$store.state.inquilino.fantasia,
      };
    },

    clienteCofreInteligente() {
      const permissions = this.$store.state.permissoes || [];
      // Verifica se o estado da loja contém a permissão desejada
      return permissions.includes("ROLE_Equipamento_Movement_Cliente");
    },
  },
  methods: {
    hasSupportMenuAccess(scope) {
      const normalizedScope = String(scope || "").toUpperCase();
      if (normalizedScope === "PROJETO") {
        return this.hasProjectSupportAccess;
      }
      if (normalizedScope === "INTERNO") {
        return this.hasInternalSupportAccess;
      }
      return false;
    },
    visibleMenuTree(items = []) {
      return items.map((item) =>
        Array.isArray(item.items)
          ? {
              ...item,
              items: this.visibleMenuTree(this.visibleMenuChildren(item.items)),
            }
          : item,
      );
    },
    visibleMenuChildren(items = []) {
      const permissions = this.$store.state.permissoes || [];

      if (!Array.isArray(items)) return [];

      return items.filter(
        (item) =>
          item &&
          hasPermission(item.can, permissions) &&
          (!item.supportPermission ||
            this.hasScopedSupportPermission(
              item.supportPermission,
              item.supportScope,
            )) &&
          (!item.projectSupportOnly || this.hasProjectSupportAccess) &&
          (!item.requiresEsocialEnvio ||
            this.$store.state.inquilino?.esocialEnvioAtivo === true) &&
          hasModulo(item.modulo, this.$store.state),
      );
    },
    hasScopedSupportPermission(level, requestedScope = null) {
      const state = this.$store?.state || {};
      const normalizedScope = String(requestedScope || "").toUpperCase();
      if (normalizedScope === "PROJETO") {
        return hasProjectSupportPermission(state, level);
      }
      if (normalizedScope === "INTERNO") {
        return (
          this.hasInternalSupportOption &&
          hasInternalSupportPermission(state, level)
        );
      }
      return (
        hasProjectSupportPermission(state, level) ||
        (this.hasInternalSupportOption &&
          hasInternalSupportPermission(state, level))
      );
    },
    menuItemKey(item, index, parentKey = "") {
      return [parentKey, item?.link, item?.title, index]
        .filter(
          (value) => value !== null && value !== undefined && value !== "",
        )
        .join("::");
    },
    handleDrawerInput(value) {
      if (this.$vuetify.breakpoint.mobile) {
        this.$emit("drawer-toggle", value);
      }
    },
    showTutorialMenuRoute(event) {
      const routePath = event?.detail?.routePath || "";
      const focus = event?.detail?.focus || "item";
      const match = this.findTutorialMenuPath(routePath);
      if (!routePath || !match) {
        window.dispatchEvent(
          new CustomEvent("tutorial:menu-route-ready", {
            detail: { routePath, focus, groupTitle: "", found: false },
          }),
        );
        return;
      }

      this.$emit("drawer-toggle", true);
      this.mini = false;
      this.togglerActive = false;
      document.body?.classList.remove("drawer-mini");

      this.resetTutorialMenuActive(this.items);
      if (focus === "item") {
        match.path.forEach((item) => {
          this.$set(item, "active", true);
        });
      }

      this.$nextTick(() => {
        setTimeout(() => {
          const target =
            focus === "group"
              ? this.findVisibleTutorialMenuGroup(match.path[0]?.title)
              : this.findVisibleTutorialMenuLink(routePath);
          if (target) {
            this.scrollTutorialMenuTargetIntoView(target);
          }

          setTimeout(() => {
            window.dispatchEvent(
              new CustomEvent("tutorial:menu-route-ready", {
                detail: {
                  routePath,
                  focus,
                  groupTitle: match.path[0]?.title || "",
                  found: Boolean(target),
                },
              }),
            );
          }, 220);
        }, 180);
      });
    },
    handleTutorialExpandMenuRoute(event) {
      const routePath = event?.detail?.routePath || "";
      const match = this.findTutorialMenuPath(routePath);
      if (!match) return;

      match.path.forEach((item) => {
        this.$set(item, "active", true);
      });
    },
    handleTutorialMenuRouteSelected(event) {
      const routePath = event?.detail?.routePath || "";
      const target = this.findVisibleTutorialMenuLink(routePath);

      if (target) {
        this.handleNavigationSelect({ target });
      } else if (this.$vuetify.breakpoint.mobile) {
        this.$emit("drawer-toggle", false);
      }
    },
    findTutorialMenuPath(routePath) {
      const permissions = this.$store.state.permissoes || [];
      const matches = [];

      const walk = (items = [], path = []) => {
        items.forEach((item) => {
          if (!hasPermission(item?.can, permissions)) return;

          const nextPath = [...path, item];
          if (item?.link && routeMatchesMenuLink(routePath, item.link)) {
            matches.push({
              path: nextPath,
              weight: normalizeMenuPath(item.link).length,
            });
          }

          walk(item?.items || item?.children || [], nextPath);
        });
      };

      walk(this.computedItems);
      return matches.sort((a, b) => b.weight - a.weight)[0] || null;
    },
    findVisibleTutorialMenuLink(routePath) {
      const targetPath = normalizeMenuPath(routePath);
      const links = Array.from(
        document.querySelectorAll("[data-tutorial-menu-link]"),
      );

      return (
        links.find((item) => {
          if (!(item instanceof HTMLElement) || item.offsetParent === null) {
            return false;
          }

          return (
            normalizeMenuPath(item.getAttribute("data-tutorial-menu-link")) ===
            targetPath
          );
        }) || null
      );
    },
    findVisibleTutorialMenuGroup(groupTitle) {
      const groups = Array.from(
        document.querySelectorAll('[data-tutorial-menu-source="drawer-group"]'),
      );
      const group = groups.find(
        (item) =>
          item instanceof HTMLElement &&
          item.getAttribute("data-tutorial-menu-group-title") === groupTitle &&
          item.offsetParent !== null,
      );

      return group?.querySelector(".v-list-group__header") || group || null;
    },
    scrollTutorialMenuTargetIntoView(target) {
      const container =
        target.closest(".v-navigation-drawer__content") ||
        target.closest(".v-navigation-drawer") ||
        null;

      if (container && container.scrollHeight > container.clientHeight) {
        const containerRect = container.getBoundingClientRect();
        const targetRect = target.getBoundingClientRect();
        container.scrollTop +=
          targetRect.top -
          containerRect.top -
          container.clientHeight / 2 +
          targetRect.height / 2;
        return;
      }

      if (typeof target.scrollIntoView === "function") {
        target.scrollIntoView({
          behavior: "auto",
          block: "center",
          inline: "nearest",
        });
      }
    },
    resetTutorialMenuActive(items = []) {
      items.forEach((item) => {
        if (item && Object.prototype.hasOwnProperty.call(item, "active")) {
          this.$set(item, "active", false);
        }
        this.resetTutorialMenuActive(item?.items || item?.children || []);
      });
    },
    handleNavigationSelect(event) {
      if (event && event.target) {
        this.listClose(event);
      }

      if (this.$vuetify.breakpoint.mobile) {
        this.$emit("drawer-toggle", false);
      }
    },
    listClose(event) {
      let items;
      let headers;
      let groups;
      let currentEl;

      if (
        document.querySelectorAll(
          ".mb-0.v-list-item.v-list-item--link.item-active",
        )
      ) {
        items = document.querySelectorAll(
          ".mb-0.v-list-item.v-list-item--link.item-active",
        );
      }

      if (
        document.querySelectorAll(
          ".mb-0.v-list-item.v-list-item--link .v-list-group__header.v-list-item--active",
        )
      ) {
        headers = document.querySelectorAll(
          ".mb-0.v-list-item.v-list-item--link .v-list-group__header.v-list-item--active",
        );
      }

      if (
        document.querySelectorAll(
          ".mb-0.v-list-item.v-list-item--link .v-list-group .v-list .v-list-group.v-list-group--active, .mb-0.v-list-item.v-list-item--link .v-list-group.v-list-group--active",
        )
      ) {
        groups = document.querySelectorAll(
          ".mb-0.v-list-item.v-list-item--link .v-list-group .v-list .v-list-group.v-list-group--active, .mb-0.v-list-item.v-list-item--link .v-list-group.v-list-group--active",
        );
      }

      if (
        event.target.closest(
          ".mb-0.v-list-item.v-list-item--link .v-list-item__content.ms-6 .v-list-group",
        )
      ) {
        currentEl = event.target.closest(
          ".mb-0.v-list-item.v-list-item--link .v-list-item__content.ms-6 .v-list-group",
        );
      }

      if (items != null) {
        for (var i = 0; i < items.length; i++) {
          items[i].classList.remove("item-active");
        }
      }

      if (headers != null) {
        for (var j = 0; j < headers.length; j++) {
          headers[j].classList.remove(
            "v-list-item--active",
            "item-active",
            "primary--text",
          );
          headers[j].setAttribute("aria-expanded", false);
        }
      }

      if (groups != null) {
        for (var k = 0; k < groups.length; k++) {
          groups[k].classList.remove("v-list-group--active", "primary--text");
        }
      }

      if (event.target.closest(".mb-0.v-list-item.v-list-item--link")) {
        event.target
          .closest(".mb-0.v-list-item.v-list-item--link")
          .classList.add("item-active");
      }

      if (currentEl != null) {
        currentEl
          .querySelector(".v-list-group__header")
          .classList.add("v-list-item--active", "item-active");
      }
    },
    mapItem(item) {
      return {
        ...item,
        children: item.children
          ? item.children.map(this.mapItem).filter((item) => {
              //Filtra os children itens que nao tem permissoes
              if (item[3]) {
                if (
                  !this.$store.state.permissoes.includes(
                    item[3].replace(/'/g, "").replace(/"/g, ""),
                  )
                ) {
                  return false;
                } else {
                  return true;
                }
              } else {
                return true;
              }
            })
          : undefined,
        title: this.$t(item.title),
        isActive: this.shouldItemBeActive(item),
      };
    },

    shouldItemBeActive(item) {
      if (item.children) {
        let should = false;
        item.children.forEach((children) => {
          if (window.location.pathname.includes(children[2])) {
            should = true;
          }
        });
        return should;
      }
    },
  },
  mounted() {
    window.addEventListener(
      "tutorial:show-menu-route",
      this.showTutorialMenuRoute,
    );
    window.addEventListener(
      "tutorial:expand-menu-route",
      this.handleTutorialExpandMenuRoute,
    );
    window.addEventListener(
      "tutorial:menu-route-selected",
      this.handleTutorialMenuRouteSelected,
    );
  },
  beforeDestroy() {
    window.removeEventListener(
      "tutorial:show-menu-route",
      this.showTutorialMenuRoute,
    );
    window.removeEventListener(
      "tutorial:expand-menu-route",
      this.handleTutorialExpandMenuRoute,
    );
    window.removeEventListener(
      "tutorial:menu-route-selected",
      this.handleTutorialMenuRouteSelected,
    );
  },
  watch: {
    navigationMenuItems: {
      immediate: true,
      handler(items) {
        this.$emit("navigation-items-change", items);
      },
    },
  },
};
</script>

<style scoped>
.app-drawer--mobile {
  border-radius: 0 14px 14px 0 !important;
  height: 100vh !important;
  margin: 0 !important;
  max-height: 100vh !important;
  max-width: 336px !important;
  top: 0 !important;
  width: 86vw !important;
}

.app-drawer--mobile ::v-deep .v-navigation-drawer__content {
  padding-bottom: 18px;
}

.app-drawer--mobile ::v-deep .v-navigation-drawer-brand {
  padding: 16px !important;
}

.drawer-brand-list-item {
  height: auto !important;
  min-height: 78px;
}

.app-drawer ::v-deep .v-navigation-drawer-brand {
  gap: 10px;
  min-width: 0;
  width: 100%;
}

.app-drawer ::v-deep .v-navigation-drawer-brand .v-avatar {
  flex: 0 0 auto;
}

@media (max-width: 360px) {
  .app-drawer--mobile {
    max-width: calc(100vw - 16px) !important;
    width: calc(100vw - 16px) !important;
  }
}
</style>
